interface MonchiqueCoFinancingLogoProps {
    className?: string;
}
export default function MonchiqueCoFinancingLogo({
    className = '',
}: MonchiqueCoFinancingLogoProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            // xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 375 75"
        >
            <defs>
                <style>
                    {`   
      .st0 {
        fill: #334722;
      }

      .st1 {
        fill: #314320;
      }

      .st2, .st3 {
        fill: #f4e846;
      }

      .st4 {
        fill: #579c47;
      }

      .st5 {
        fill: #4d833e;
      }

      .st6 {
        fill: #395428;
      }

      .st7 {
        fill: #4c803c;
      }

      .st8 {
        fill: url(#Gradiente_sem_nome_5);
      }

      .st9 {
        fill: #436a33;
      }

      .st10 {
        fill: #519043;
      }

      .st11 {
        fill: #385228;
      }

      .st12 {
        fill: #4b7a39;
      }

      .st13 {
        fill: #497538;
      }

      .st14 {
        fill: #61b454;
      }

      .st15 {
        clip-path: url(#clippath-4);
      }

      .st16 {
        fill: #3d5d2c;
      }

      .st17 {
        fill: url(#Gradiente_sem_nome_8);
        opacity: .1;
      }

      .st17, .st18, .st19, .st20, .st21, .st3, .st22, .st23 {
        fill-rule: evenodd;
      }

      .st17, .st18, .st21, .st24, .st25, .st22 {
        isolation: isolate;
      }

      .st17, .st18, .st21, .st22 {
        mix-blend-mode: multiply;
      }

      .st26 {
        fill: #539344;
      }

      .st27 {
        fill: #4d833f;
      }

      .st28 {
        fill: #080a14;
      }

      .st29 {
        fill: #50873f;
      }

      .st18 {
        fill: url(#Gradiente_sem_nome_9);
      }

      .st18, .st21 {
        opacity: .75;
      }

      .st30 {
        fill: #529143;
      }

      .st31 {
        fill: #5aaa4c;
      }

      .st32 {
        fill: #5cb250;
      }

      .st33 {
        fill: #456f35;
      }

      .st34 {
        fill: #3b3c42;
      }

      .st35 {
        fill: #3b592b;
      }

      .st36 {
        fill: #4e863f;
      }

      .st37 {
        fill: url(#Gradiente_sem_nome_2);
      }

      .st38 {
        fill: #59a84c;
      }

      .st39 {
        fill: #5bab4d;
      }

      .st40 {
        fill: #59ab4c;
      }

      .st41, .st19 {
        fill: #fff;
      }

      .st42 {
        fill: #204d9c;
      }

      .st43 {
        fill: #5caf4e;
      }

      .st44 {
        fill: #e52628;
      }

      .st45 {
        fill: #426832;
      }

      .st46 {
        fill: #569a46;
      }

      .st47 {
        fill: #3e602e;
      }

      .st48 {
        fill: #466d34;
      }

      .st49 {
        fill: #4a7a39;
      }

      .st50 {
        fill: #334821;
      }

      .st51 {
        fill: #5cac4d;
      }

      .st52 {
        fill: none;
      }

      .st53 {
        fill: #00743d;
      }

      .st54 {
        fill: #45454b;
      }

      .st55 {
        fill: #406230;
      }

      .st56 {
        fill: url(#Gradiente_sem_nome);
      }

      .st57 {
        fill: #3a562a;
      }

      .st58 {
        fill: #529244;
      }

      .st59 {
        fill: #497738;
      }

      .st60 {
        fill: #385328;
      }

      .st61 {
        fill: #436933;
      }

      .st62 {
        fill: #406430;
      }

      .st63 {
        fill: #4d823e;
      }

      .st64 {
        fill: #467036;
      }

      .st20 {
        fill: #25326a;
      }

      .st65 {
        fill: #5bad4d;
      }

      .st66 {
        fill: #518f42;
      }

      .st67 {
        fill: #58a74b;
      }

      .st68 {
        fill: #3e5e2e;
      }

      .st69 {
        fill: #508b40;
      }

      .st70 {
        fill: #559545;
      }

      .st71 {
        fill: #3b572a;
      }

      .st72 {
        fill: #354a23;
      }

      .st73 {
        clip-path: url(#clippath-1);
      }

      .st74 {
        fill: #4b7d3a;
      }

      .st75 {
        fill: #569745;
      }

      .st21 {
        fill: url(#Gradiente_sem_nome_7);
      }

      .st76 {
        fill: #5cb350;
      }

      .st77 {
        fill: #40612f;
      }

      .st78 {
        fill: #487438;
      }

      .st79 {
        fill: #406531;
      }

      .st80 {
        fill: #487638;
      }

      .st81 {
        fill: #467136;
      }

      .st82 {
        fill: #324421;
      }

      .st83 {
        fill: #395529;
      }

      .st84 {
        clip-path: url(#clippath-5);
      }

      .st85 {
        fill: #4d813d;
      }

      .st86 {
        fill: #60b453;
      }

      .st87 {
        fill: #4f873f;
      }

      .st88 {
        fill: #4e843f;
      }

      .st25 {
        fill: #5b5c63;
        font-family: ArialMT, Arial;
        font-size: 7.88px;
      }

      .st89 {
        fill: #324621;
      }

      .st90 {
        fill: #395429;
      }

      .st91 {
        fill: #477237;
      }

      .st92 {
        fill: #477337;
      }

      .st93 {
        clip-path: url(#clippath-3);
      }

      .st94 {
        fill: #3a5629;
      }

      .st95 {
        fill: #5bae4e;
      }

      .st96 {
        fill: #559b47;
      }

      .st97 {
        fill: #364f26;
      }

      .st98 {
        fill: #5db14f;
      }

      .st22 {
        fill: url(#Gradiente_sem_nome_6);
        opacity: .82;
      }

      .st99 {
        fill: #50883f;
      }

      .st100 {
        fill: #446c34;
      }

      .st101 {
        fill: #4d813e;
      }

      .st102 {
        fill: #4b7b3a;
      }

      .st103 {
        fill: #385027;
      }

      .st104 {
        fill: #4c7f3c;
      }

      .st105 {
        fill: url(#Gradiente_sem_nome_4);
      }

      .st106 {
        fill: #334a22;
      }

      .st107 {
        fill: #3b5a2b;
      }

      .st108 {
        fill: #416631;
      }

      .st109 {
        fill: #3d5b2b;
      }

      .st110 {
        fill: #364d24;
      }

      .st111 {
        fill: #497839;
      }

      .st112 {
        fill: #62b453;
      }

      .st113 {
        fill: #3f5f2e;
      }

      .st114 {
        fill: #3f612f;
      }

      .st115 {
        fill: #375026;
      }

      .st116 {
        fill: #89c056;
      }

      .st117 {
        fill: #5fb352;
      }

      .st118 {
        fill: #518d41;
      }

      .st119 {
        fill: #4a7c3a;
      }

      .st120 {
        fill: #569f49;
      }

      .st121 {
        fill: #569e48;
      }

      .st122 {
        fill: #518d42;
      }

      .st123 {
        fill: #3b582b;
      }

      .st124 {
        fill: #426732;
      }

      .st125 {
        fill: #4b7e3b;
      }

      .st126 {
        fill: #57a148;
      }

      .st127 {
        fill: #5db350;
      }

      .st128 {
        fill: #579d48;
      }

      .st129 {
        fill: #508940;
      }

      .st130 {
        clip-path: url(#clippath-2);
      }

      .st131 {
        fill: #457035;
      }

      .st132 {
        fill: #466e35;
      }

      .st133 {
        fill: url(#Gradiente_sem_nome_3);
      }

      .st134 {
        fill: #57a24a;
      }

      .st135 {
        fill: #3c5a2c;
      }

      .st136 {
        fill: #406330;
      }

      .st137 {
        fill: #487537;
      }

      .st138 {
        fill: #385127;
      }

      .st139 {
        fill: #f5e948;
      }

      .st140 {
        fill: #57a54b;
      }

      .st141 {
        fill: #436b34;
      }

      .st23 {
        fill: #54b258;
      }

      .st142 {
        fill: #508a40;
      }

      .st143 {
        fill: #3c5c2c;
      }

      .st144 {
        fill: #56a349;
      }

      .st145 {
        fill: #334922;
      }

      .st146 {
        fill: #57a248;
      }

      .st147 {
        clip-path: url(#clippath);
      }

      .st148 {
        fill: #3d5e2c;
      }

      .st149 {
        fill: #518c41;
      }

      .st150 {
        fill: #324721;
      }

      .st151 {
        fill: #354b23;
      }

      .st152 {
        fill: #fab420;
      }

      .st153 {
        fill: #569a47;
      }

      .st154 {
        fill: #0c4f82;
      }

      .st155 {
        fill: #569847;
      }
      `}
                </style>
                <clipPath id="clippath">
                    <path
                        className="st52"
                        d="M25.37,26.05c-4.44.06-8.29,2.59-10.23,6.28-.81-2.18-.67-4.28,2.53-6.29-.46.26-.91.54-1.35.84,2.06-1.43,3.02-1.65,3.02-1.65,3.09-1.07,4.98-.77,6.03.82Z"
                    />
                </clipPath>
                <linearGradient
                    id="Gradiente_sem_nome"
                    data-name="Gradiente sem nome"
                    x1="154.43"
                    y1="-167.69"
                    x2="154.5"
                    y2="-154.98"
                    gradientTransform="translate(-141.13 185.37) rotate(-90) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".33" stopColor="#235f2f" />
                    <stop offset=".69" stopColor="#3fa24a" />
                    <stop offset="1" stopColor="#66b76d" />
                </linearGradient>
                <clipPath id="clippath-1">
                    <path
                        className="st52"
                        d="M37.77,50.76l-.02.03c-3.76,3.54-6.06,1.38-7.3-2.32,3.9-1.79,6.65-5.66,6.83-10.18.77.48,1.74.89,2.22,1.62,2.22,3.35.96,7.59-1.72,10.86h0Z"
                    />
                </clipPath>
                <linearGradient
                    id="Gradiente_sem_nome_2"
                    data-name="Gradiente sem nome 2"
                    x1="-21.03"
                    y1="174.39"
                    x2="-20.94"
                    y2="191.42"
                    gradientTransform="translate(16.43 -136.64) rotate(-180) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".33" stopColor="#235f2f" />
                    <stop offset=".69" stopColor="#3fa24a" />
                    <stop offset="1" stopColor="#66b76d" />
                </linearGradient>
                <clipPath id="clippath-2">
                    <path
                        className="st52"
                        d="M25.54,24c8.93,0,16.18,7.24,16.18,16.18,0,4.06-1.49,7.76-3.96,10.6,2.69-3.27,3.66-7.36,1.44-10.72s-8.32-3.08-10.54-7.97c-2.22-4.9-3.27-8.74-9.31-6.85,1.91-.79,4-1.23,6.19-1.23h0Z"
                    />
                </clipPath>
                <linearGradient
                    id="Gradiente_sem_nome_3"
                    data-name="Gradiente sem nome 3"
                    x1="19.01"
                    y1="39.51"
                    x2="44.13"
                    y2="39.51"
                    gradientTransform="translate(0 75.04) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".28" stopColor="#235f2f" />
                    <stop offset=".56" stopColor="#3fa24a" />
                    <stop offset=".77" stopColor="#6ab972" />
                </linearGradient>
                <clipPath id="clippath-3">
                    <path
                        className="st52"
                        d="M37.75,50.79c-2.97,3.41-7.34,5.57-12.21,5.57-8.93,0-16.18-7.24-16.18-16.18,0,7.39,10.35-.59,15.51,1.33,5.3,1.97,6.42,15.47,12.88,9.28Z"
                    />
                </clipPath>
                <clipPath id="clippath-4">
                    <rect
                        className="st52"
                        x="9.36"
                        y="39.59"
                        width="28.39"
                        height="17.39"
                    />
                </clipPath>
                <linearGradient
                    id="Gradiente_sem_nome_4"
                    data-name="Gradiente sem nome 4"
                    x1="8.83"
                    y1="25.49"
                    x2="36.75"
                    y2="25.49"
                    gradientTransform="translate(0 75.04) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".27" stopColor="#235f2f" />
                    <stop offset=".72" stopColor="#3fa24a" />
                </linearGradient>
                <clipPath id="clippath-5">
                    <path
                        className="st52"
                        d="M25.54,56.35c-8.93,0-16.18-7.24-16.18-16.18,0-6.08,3.35-11.37,8.31-14.14-5.64,4.15-.9,8.86-.07,13.71,1,5.85-4.71,15.46,7.94,16.6h0Z"
                    />
                </clipPath>
                <linearGradient
                    id="Gradiente_sem_nome_5"
                    data-name="Gradiente sem nome 5"
                    x1="-.25"
                    y1="162.35"
                    x2="-.07"
                    y2="194.32"
                    gradientTransform="translate(16.43 -136.64) rotate(-180) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".23" stopColor="#235f2f" />
                    <stop offset=".51" stopColor="#3fa24a" />
                    <stop offset=".78" stopColor="#66b76d" />
                </linearGradient>
                <linearGradient
                    id="Gradiente_sem_nome_6"
                    data-name="Gradiente sem nome 6"
                    x1="10.61"
                    y1="22.97"
                    x2="23.48"
                    y2="30.13"
                    gradientTransform="translate(0 75.04) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".22" stopColor="#fff" stopOpacity="0" />
                    <stop offset=".23" stopColor="#f5faf9" stopOpacity=".04" />
                    <stop offset=".29" stopColor="#b8dfd4" stopOpacity=".3" />
                    <stop offset=".35" stopColor="#83c8b5" stopOpacity=".51" />
                    <stop offset=".41" stopColor="#59b59c" stopOpacity=".69" />
                    <stop offset=".48" stopColor="#38a788" stopOpacity=".83" />
                    <stop offset=".56" stopColor="#209c7a" stopOpacity=".93" />
                    <stop offset=".66" stopColor="#139672" stopOpacity=".98" />
                    <stop offset=".81" stopColor="#0f9570" />
                </linearGradient>
                <linearGradient
                    id="Gradiente_sem_nome_7"
                    data-name="Gradiente sem nome 7"
                    x1="30.44"
                    y1="24.79"
                    x2="37.77"
                    y2="24.79"
                    gradientTransform="translate(0 75.04) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#fff" stopOpacity="0" />
                    <stop offset=".11" stopColor="#adabac" stopOpacity=".37" />
                    <stop offset=".28" stopColor="#5e5b5c" stopOpacity=".73" />
                    <stop offset=".5" stopColor="#302c2d" stopOpacity=".94" />
                    <stop offset="1" stopColor="#231f20" />
                </linearGradient>
                <linearGradient
                    id="Gradiente_sem_nome_8"
                    data-name="Gradiente sem nome 8"
                    x1="17.16"
                    y1="26.16"
                    x2="25.54"
                    y2="26.16"
                    gradientTransform="translate(0 75.04) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#fff" stopOpacity="0" />
                    <stop offset=".11" stopColor="#adabac" stopOpacity=".37" />
                    <stop offset=".28" stopColor="#5e5b5c" stopOpacity=".73" />
                    <stop offset=".5" stopColor="#302c2d" stopOpacity=".94" />
                    <stop offset="1" stopColor="#231f20" />
                </linearGradient>
                <linearGradient
                    id="Gradiente_sem_nome_9"
                    data-name="Gradiente sem nome 9"
                    x1="17.16"
                    y1="25.9"
                    x2="25.54"
                    y2="25.9"
                    gradientTransform="translate(0 75.04) scale(1 -1)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#fff" stopOpacity="0" />
                    <stop offset=".11" stopColor="#adabac" stopOpacity=".37" />
                    <stop offset=".28" stopColor="#5e5b5c" stopOpacity=".73" />
                    <stop offset=".5" stopColor="#302c2d" stopOpacity=".94" />
                    <stop offset="1" stopColor="#231f20" />
                </linearGradient>
            </defs>
            <g className="st24">
                <g id="Camada_1">
                    <g>
                        <g>
                            <path
                                className="st53"
                                d="M130.2,23.83c-6.14,1.98-9.25,7.19-9.25,15.24v12.2s1.03-7.84,9.25-10.1v-17.33h0Z"
                            />
                            <path
                                className="st44"
                                d="M130.88,26.13s4.67-1.77,11.32-2.15c0,0-.02,5.55-.2,10.06-.56,14.25-13.3,6.93-19.54,14.51,1.25-3.28,5.51-5.61,8.42-6.19v-16.24h0Z"
                            />
                            <path
                                className="st53"
                                d="M129.16,46.48s-6.77.55-7.35,4.41c-.46,3.03,7.35,3.11,7.35,3.11v-7.51h0Z"
                            />
                            <path
                                className="st116"
                                d="M121.24,35.12c1.4-3.27,3.78-6.62,8.96-8.72v-2.58c-5.07,1.63-8.07,5.48-8.96,11.29h0Z"
                            />
                            <path
                                className="st152"
                                d="M125.37,31.58h.31s.04,0,.07.01h.02s.05.01.07.02h0c.08.02.17.05.26.08h.06s.06.02.08.03h.07s.02,0,.04.01h.1s.03.01.04.02h0s.02,0,.03.01h.02s.02,0,.03.01h.01s.03.01.04.02v-.35c-.05.01-.1.02-.15.03-.04,0-.09.02-.13.03h0s-.03,0-.04-.01h-.11c-.1-.03-.19-.06-.28-.09h-.02s0,0,0,0c0,0-.02,0-.02,0h-.03s0,0,0,0c0,0,.02,0,.03-.01h.04s.02,0,.04-.01h0s.05-.02.08-.02h0s.03,0,.04-.01h0c.17-.05.36-.1.57-.15v-.17h0v-.22c-.1.09-.2.19-.29.29-.23.06-.44.13-.62.19,1.01-1.32,2.56-2.2,4.31-2.33l.02-.16c-1.89.12-3.55,1.1-4.59,2.56-.09,0-.15.02-.19.05h0l-.09.16s-.01.04,0,.08c0-.05.04-.1.12-.12l.06.05ZM125.73,31.42h0ZM130.04,29.51c-1.03.09-1.98.47-2.77,1.06h-.25c.85-.69,1.9-1.13,3.04-1.22l-.02.16ZM124.81,32.6v-.1l.08-.15h0s.06-.03.1-.03h.03s.09,0,.14,0h0c.1.02.22.04.35.08.05,0,.1.03.15.05h0s.04,0,.05.02h.09s.02,0,.03,0h0s.02,0,.03,0h.06s.02,0,.03,0h0s.02,0,.03,0h.03s.02,0,.03,0h.12s.02,0,.03,0h.04s.02,0,.03,0h.27s.02,0,.03,0h0s.03,0,.04,0v.18c-.43-.19-.8-.34-1.1-.44h0c-.05-.02-.1-.03-.15-.05h0c-.14-.04-.26-.06-.35-.08h-.15c-.06,0-.11.03-.13.13l.09.29ZM126.66,38.8c.88.89,2.06,1.47,3.37,1.59l.02.16c-1.67-.14-3.14-1.02-4.08-2.31h.2c.14.19.3.36.46.53h.01s.02.03.02.03ZM130.72,28.83v-.1h0s.13-.01.13-.01c0,0,.02,0,.02.02v.1c1.94.11,3.63,1.12,4.67,2.61.08.04.14.07.19.11h0s.09.16.12.19c.02.03,0,.07-.03.08.02-.02.03-.03-.03-.08-.02-.02-.04-.03-.06-.05h0s0,0-.02-.01h0c-.08-.05-.18-.09-.28-.14h0s-.02,0-.03-.01h0s-.02,0-.03-.01h0s-.02,0-.03-.01h0s-.02,0-.03-.01h0s-.02,0-.03-.01h0s-.02,0-.03-.01h0s-.02,0-.03-.01h0s-.05-.01-.07-.02h0s-.02,0-.03-.01h0s-.02,0-.03-.01h0s-.02,0-.04-.01h-.04s-.02,0-.04-.01h-.04s0,0,0,0c-.1-.03-.2-.06-.31-.08h0s-.03,0-.05-.01h0s-.03,0-.05-.02h-.05s-.03,0-.05-.01h0v-.17h0v-.22c.1.09.19.19.29.29.23.06.44.13.61.19-1.02-1.33-2.6-2.22-4.39-2.32v.34c1.2.07,2.3.52,3.19,1.24h-.26c-.83-.62-1.83-1.01-2.93-1.08v1.07h-.16v-1.74l-.04-.07ZM135.91,32c.06.03.1.06.12.08,0,0,.07.13.09.16.02.03,0,.07-.04.08.02,0,.05-.04-.02-.07-.02,0-.04-.02-.05-.03h0c-.17-.09-.41-.17-.72-.26h0c-.07-.02-.15-.04-.23-.06h0c-.21-.05-.44-.11-.69-.16v-.17s.06.01.09.02h.35c.08.02.16.04.24.06h.03s.05.01.07.02h0s.07.02.1.03h0c.11.03.21.07.3.1h0c.09.03.18.06.24.09h0l.11.11ZM130.19,28.84h-.03.03ZM124.33,34.81v-.16h0s.05-.08.1-.12c.04-.65.19-1.27.42-1.86h0s0,0,.01-.02c0,0,0-.02.01-.03h0s.02-.04.03-.06v-.02s.08.02.15.05c-.25.57-.41,1.19-.46,1.83.1-.06.22-.12.36-.17.07-.52.2-1.01.39-1.47.04.04.08.08.12.13-.03.08-.06.16-.09.25h0c-.11.33-.2.67-.25,1.02.37-.14.85-.26,1.37-.36.07-.02.14-.03.2-.04v.17c-.06,0-.12.02-.17.03h-.3s-.03,0-.05,0h-.04s-.03,0-.04,0h0s-.03,0-.05,0h0s-.03,0-.05,0h0s-.03,0-.04,0h0s-.03,0-.05,0h0s-.03,0-.05,0h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.06.02-.09.03h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.06.02-.08.03h0s-.03,0-.04,0h0s-.02,0-.04,0h0s-.05.02-.08.03h0s-.02,0-.04,0h0s-.03,0-.04.02h0c-.06.02-.11.04-.16.07h-.04s-.03.02-.05.02h0s-.01,0-.02,0h0s-.02,0-.02,0h0s-.02,0-.02,0h-.02s-.02,0-.02,0h0s-.03.02-.04.02h0s-.01,0-.02,0h0s-.03.02-.04.02h-.02s-.01,0-.02,0h0c-.06.04-.11.08-.15.12h0s-.08.08-.05.11c-.02,0-.03-.02-.03-.04l-.11.17ZM130.2,29.34v-.61s0-.02.02-.02h.13s0,0,0,.02v1.84h-.16v-1.23ZM135.51,38.59s0,.07,0,.09c0,0-.05.08-.07.11s-.05.06-.11.07c0,0,.11-.02.05-.16h0s0-.03-.02-.05c-.02-.03-.04-.06-.07-.11h0c-.05-.07-.13-.16-.24-.26h0s-.07-.07-.12-.11h0c-.24-.22-.56-.49-.97-.8.03-.05.05-.11.08-.16h0c.48.36.88.68,1.14.93h0s.04.04.06.06h0s0,0,0,.02t0,0s0,0,0,.02h0s0,0,0,.02h0s0,0,0,.02h0s0,0,0,.02h0s.02.02.03.03h0s0,0,0,.02t0,0s0,0,0,0h0c.04.06.08.11.09.15h0v.02l.09.06ZM135.34,38.75s-.03.04-.04.05h0s-.02.03-.04.05c-1.05,1.27-2.61,2.11-4.37,2.21v.09h0s0,0,0,0h-.13s-.02,0-.02-.02v-1.65h.16v.9c1.36-.09,2.59-.67,3.5-1.57h0s.02-.03.04-.04h0c.11-.11.22-.23.32-.36.06.02.11.03.16.05-.96,1.19-2.4,1.98-4.03,2.08v.35c1.76-.1,3.31-.96,4.34-2.27.06.05.1.08.12.11h0ZM136.64,35.35v.09h0c-.06.79-.27,1.54-.61,2.22.04.08.05.15.02.21,0,0-.05.07-.08.11-.02.04-.03.05-.08.06.03,0,.08-.07.06-.16h0s0-.03,0-.05h0s-.02-.05-.04-.08c-.04-.07-.1-.14-.16-.21h0s0,0,0-.02h0s0-.02,0-.02h0c-.07-.08-.16-.17-.25-.26h0s-.02-.02-.02-.03h0s-.06-.05-.09-.08h0s-.02-.02-.03-.02h0s-.06-.06-.1-.09h0s-.02-.02-.03-.02h0s-.07-.06-.1-.09h0s-.02-.02-.03-.02h0s-.02-.02-.03-.03h0s-.05-.04-.07-.06h0s-.02-.02-.03-.02h0s-.02-.02-.03-.03h0s-.02-.02-.04-.03h0s-.02-.02-.03-.03h0s-.02,0-.03-.02h0s-.02-.02-.03-.02h0s-.03-.02-.04-.03t0,0s-.02-.02-.04-.03h0s-.02-.02-.03-.02h0s-.02,0-.03-.02h0s-.03-.02-.04-.03h0s-.02-.02-.04-.02h0s-.02,0-.03-.02h0s-.02,0-.03-.02h0s-.03-.02-.04-.03c0-.07.02-.13.03-.2.5.36.92.7,1.22.99.19-.44.32-.92.39-1.41h0v-.03h0v-.06h0v-.37h.16c-.03.7-.2,1.37-.46,1.98.1.1.18.2.25.28.32-.67.51-1.42.56-2.2.05.02.1.04.16.06l-.09-.12ZM136.74,34.65h0v.16s0,.03-.03.04c.02-.02,0-.06-.03-.09h0s0,0-.02-.02h0s-.09-.09-.16-.13h0s0,0-.02,0h-.02s0,0-.02,0h0s0,0-.02,0h-.02s0,0-.02,0h-.04s0,0-.02,0h0s0,0-.02,0h0s0,0-.02,0h-.02s0,0-.02,0h-.02c-.06-.02-.12-.05-.19-.08h0s-.03,0-.04,0t0,0s-.02,0-.04,0t0,0s-.03,0-.04,0h0s-.03,0-.04-.02h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.05-.02-.08-.03h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.06-.02-.09-.03h0s-.03,0-.04,0h0s-.03,0-.04,0h0s-.03,0-.05,0h0s-.03,0-.05,0h0s-.03,0-.04,0h-.04s-.03,0-.04,0h0s-.03,0-.04,0h-.04s-.03,0-.05,0h-.3c-.05,0-.11-.02-.17-.03v-.17c.07,0,.13.02.2.04.52.1,1,.23,1.37.37-.08-.59-.26-1.14-.51-1.65h0c-.05-.11-.11-.22-.17-.33h0s.09,0,.18,0c.35.62.59,1.32.68,2.05.14.06.27.12.36.17-.07-.78-.29-1.52-.63-2.19.07,0,.13.03.2.05h0s.02.03.02.05h0c.32.68.52,1.42.57,2.2.05.04.09.08.1.12l-.13-.21ZM136.74,35.18h0v.17s-.03.04-.04.05c.03-.03,0-.08-.02-.1,0,0-.02-.02-.03-.04h0s0,0-.02-.02h0l-.02-.02s-.07-.05-.11-.08h0c-.09-.06-.21-.12-.34-.17h0s-.02,0-.03-.02c-.04-.02-.07-.03-.11-.04h0c-.42-.16-.95-.3-1.45-.4-.06,0-.12-.02-.18-.03v-.17c.07,0,.13.02.2.04h.61s.02,0,.04,0h.05s.02,0,.04,0h.43s.02,0,.03,0h0s.05.02.08.03h.12c.06.02.12.04.17.07h.06s0,0,0,0c-.01,0,.02,0,.02,0h.09s0,0,.02,0h.04c.07.04.12.08.16.11h0s.06.08.07.11l.12.46ZM124.42,35.27h0s-.02.02-.03.04-.05.06-.02.1c-.01,0-.04-.02-.04-.05v-.17h0s.03-.06.06-.1h.01s.1-.09.16-.12h.07s.03-.02.05-.02h.08s.04-.02.06-.02h0c.06-.02.12-.05.18-.07h.06s.02,0,.03,0h0s.02,0,.04,0h0s.02,0,.03,0h.48s.03,0,.05,0h.71c.07-.02.14-.03.2-.04h0v.17c-.06,0-.12.02-.18.03-.5.1-1.03.24-1.45.4h0c-.05.02-.11.04-.16.06h0c-.13.06-.25.12-.34.18h0c-.05.03-.09.06-.13.1h0l-.02.02.1-.47ZM125.41,38.33s-.03.05.02.08c-.03,0-.06-.02-.07-.05-.02-.03-.07-.11-.07-.11h0s.02-.05.04-.08h0s.07-.07.12-.1h.02s.02,0,.03-.02h.03s.02-.02.04-.02h0s.01,0,.02,0h0s.05-.03.08-.05h0s.05-.02.07-.03h0s.09-.04.15-.06c.02,0,.04-.02.06-.02h.03s.04-.02.06-.02h.03s0,0,0,0c-.01,0,.04-.02.06-.02h.03s.04-.02.06-.02h.03s.04,0,.07-.02h.03s.02,0,.03,0c.24-.07.48-.13.72-.18.03.05.06.11.09.16-.27.05-.52.12-.77.19-.38.1-.93.33-1.06.51l.05-.12ZM125.14,37.95s-.05,0-.05-.02c0-.02-.07-.13-.07-.13h0s.02-.06.04-.09c-.36-.71-.58-1.51-.63-2.35.05-.03.1-.05.15-.06.05.82.26,1.6.6,2.3.08-.05.19-.11.31-.16-.33-.67-.53-1.42-.57-2.21h.16c.04.76.23,1.49.56,2.14.2-.08.43-.16.65-.22.21-.06.42-.12.65-.17.02.05.04.11.06.16-.23.05-.45.11-.67.17h-.04s-.01,0,0,0c.02,0-.02,0-.03,0h-.07s-.05.02-.07.02h0s-.02,0-.04,0h0s-.02,0-.04,0h0s-.02,0-.04,0h0s-.05.02-.08.03h0c-.06.02-.12.05-.18.07h0c-.05.02-.1.04-.15.06h-.04s-.01,0-.02,0h0s-.07.03-.1.05h0s-.01,0-.02,0h-.04s-.06.03-.08.05h0c-.06.04-.1.08-.12.11h0s-.02.04-.02.05,0,.02.03.03l-.04.11ZM130.13,41.06h0c-1.93-.12-3.62-1.15-4.65-2.66,0,0-.02-.03-.03-.04h0s.1-.04.15-.06c1,1.47,2.63,2.47,4.51,2.6l.02.15h0ZM130.36,41.07v.09s0,.02,0,.02h-.13s-.02,0-.02-.02v-1.66c.05,0,.11,0,.16,0v1.56Z"
                            />
                            <path
                                className="st2"
                                d="M125.8,31.33c1.01-1.32,2.56-2.2,4.31-2.33l-.05.35c-1.15.1-2.2.54-3.04,1.22h-.31v.27c-.1.09-.2.19-.29.29-.23.06-.44.13-.62.19h0ZM135.84,32.23c-.16-.03-.3-.04-.41-.04.35.62.59,1.32.68,2.05.14.06.27.12.36.17-.07-.78-.29-1.52-.63-2.19h0ZM130.88,29.34c1.2.07,2.3.52,3.19,1.24h.3v.26c.1.09.19.19.29.29.23.06.44.13.61.19-1.02-1.33-2.6-2.22-4.39-2.32,0,0,0,.34,0,.34ZM125.98,38.24c-.1,0-.24.02-.38.06,1,1.47,2.63,2.47,4.51,2.6l-.05-.36c-1.67-.14-3.14-1.02-4.08-2.31h0ZM130.88,40.56v.35c1.76-.1,3.31-.96,4.34-2.27-.07-.05-.18-.12-.31-.17-.96,1.19-2.4,1.98-4.03,2.08h0ZM125.49,37.43c-.33-.67-.53-1.42-.57-2.21-.09,0-.22.02-.35.07.05.82.26,1.6.6,2.3.08-.05.19-.11.31-.16h.01ZM135.69,37.21c.1.1.18.2.25.28.32-.67.51-1.42.56-2.2-.13-.04-.24-.06-.34-.06-.03.7-.2,1.37-.46,1.98h0ZM124.96,34.25c.07-.52.2-1.01.39-1.47-.1-.09-.21-.15-.3-.19-.25.57-.41,1.19-.46,1.83.1-.06.22-.12.36-.17h.01Z"
                            />
                            <path
                                className="st2"
                                d="M135.75,31.7c-.28-.18-.84-.35-1.38-.48v.33c.68.14,1.29.32,1.55.44l-.17-.3h0Z"
                            />
                            <path
                                className="st2"
                                d="M126.42,31.61c.09-.02.19-.04.28-.06v-.31c-.3.07-.58.14-.8.22.15.04.32.09.52.16h0Z"
                            />
                            <path
                                className="st3"
                                d="M126.71,33.95c-.06,0-.12.02-.17.03-.86.17-1.83.47-2.11.75,0,0-.02.02-.03.03v.32c.24-.24,1.08-.54,2.11-.74.07-.02.14-.03.2-.04,0,0,0-.35,0-.35Z"
                            />
                            <path
                                className="st3"
                                d="M136.64,34.73c-.28-.28-1.24-.59-2.11-.75-.05,0-.11-.02-.17-.03v.35c.07,0,.13.02.2.04,1.03.2,1.85.5,2.1.74v-.32s-.02-.02-.03-.03h0Z"
                            />
                            <path
                                className="st3"
                                d="M127,37.14c-.23.05-.45.11-.67.17-.52.15-1.08.38-1.19.56h0l.19.31c.12-.14.5-.35,1.11-.52.24-.07.48-.13.72-.18-.06-.11-.11-.22-.16-.34Z"
                            />
                            <rect
                                className="st2"
                                x="130.36"
                                y="28.8"
                                width=".36"
                                height="1.77"
                            />
                            <path
                                className="st3"
                                d="M130.53,39.51h-.17v1.61h.36v-1.61h-.19Z"
                            />
                            <path
                                className="st3"
                                d="M135.9,37.74c-.24-.37-.85-.9-1.58-1.45-.05.32-.15.63-.27.92.81.6,1.38,1.1,1.46,1.35l.46-.7s-.02-.08-.06-.12h-.01Z"
                            />
                            <path
                                className="st3"
                                d="M126.7,31.89c-.53-.22-.93-.33-1.17-.33h-.01c-.06,0-.11,0-.15.02l-.38.74h.05c.29,0,.89.2,1.67.54v-.97h-.01Z"
                            />
                            <path
                                className="st28"
                                d="M134.37,32.09v.7c.42-.08.78-.17,1.07-.25-.06-.12-.12-.23-.18-.34.08,0,.41-.03.79.08h0s.02.03.02.05h.02s.04-.04-.02-.07c-.02,0-.03-.02-.05-.03h0c-.21-.11-.54-.22-.96-.33,0,0,0,.02.02.03-.2.06-.43.12-.71.18v-.02ZM136.71,34.85s0-.06-.03-.09v.1h.04,0ZM135.85,31.83s.02-.03-.04-.08c-.02-.02-.04-.03-.06-.05l.08.13h.02,0ZM135.85,38.03h.06s.07-.07.05-.16l-.11.16ZM136.7,35.33h0s0-.02-.02-.02c0-.02-.03-.03-.04-.04-.11-.09-.28-.18-.49-.27-.04-.02-.08-.03-.12-.05v.06c-.55.17-1.22.3-1.63.37v.35c0,.11,0,.22-.02.32.63-.1,1.18-.22,1.6-.34.02-.15.03-.3.04-.46.12,0,.37,0,.65.13v.09s.05-.03.06-.04c0-.02,0-.05,0-.06h0l-.03-.04ZM135.39,38.72h0v-.02h0s0-.03-.02-.05c-.05-.11-.2-.27-.42-.48h0c-.23-.22-.56-.48-.97-.79-.19.38-.44.72-.73,1.02-.34.34-.75.62-1.21.82.59-.05,1.15-.13,1.6-.22.16-.02.44-.08.74-.16.13-.13.25-.26.37-.4.34.08.54.26.59.32-.03.04-.06.07-.09.11h.08s.09-.02.06-.14q-.02-.08,0,0h0Z"
                            />
                            <path
                                className="st28"
                                d="M125.27,31.77s-.02-.05-.02-.07c0-.05.04-.1.12-.12,0,0-.1.19-.1.19ZM124.4,34.86v-.1s-.06.07-.03.09h.03ZM130.2,28.84h-.06l-.1.68c.05,0,.11-.01.16-.02v-.66ZM124.84,32.7s.04-.11.07-.16c.08.02.36.11.56.37-.05.11-.09.22-.12.34.21.18.49.4.83.64.11-.02.21-.05.32-.07.07-.02.14-.03.2-.04v-.74c-.41-.18-.77-.33-1.07-.43h-.02c-.27-.09-.47-.13-.62-.13h-.06s-.08.04-.1.13v-.02.02s.02.05.03.09h-.02ZM126.71,35.68v-.34c-.41-.07-1.08-.2-1.63-.37v-.06c-.06.02-.12.05-.18.07-.05.02-.1.04-.15.06h0c-.13.06-.22.13-.29.19-.01,0-.02.02-.03.03,0,0-.01.02-.02.02h0v.02h0s.04.03.06.04v-.09c.28-.14.54-.14.66-.13,0,.15.02.3.04.46.42.12.97.24,1.6.34-.01-.11-.02-.22-.02-.33l-.04.09ZM130.13,41.06h.06v-.66c-.05,0-.11,0-.16-.02l.1.67h0ZM127.83,38.38s-.02-.02-.04-.04c-.58-.09-1.17-.2-1.78-.34,0,0-.01-.02-.02-.02-.28.11-.5.23-.59.35-.01,0-.03.05.02.08h0s.06.02.09.04c-.02-.03-.04-.06-.05-.09.34-.16.66-.12.73-.11.15.19.3.38.47.54.66.17,1.46.31,2.34.39-.43-.19-.83-.47-1.17-.81h0ZM125.13,37.87s-.02.04-.02.05,0,.02.03.03h-.01.05s-.05-.08-.05-.08Z"
                            />
                            <path
                                className="st41"
                                d="M130.52,39.57c-2.32,0-3.87-1.96-3.87-3.79v-5.22h7.74v5.22c0,1.83-1.55,3.79-3.87,3.79h0Z"
                            />
                            <path
                                className="st44"
                                d="M126.91,30.81v4.96c0,1.71,1.45,3.53,3.61,3.53s3.61-1.83,3.61-3.53v-4.96s-7.22,0-7.22,0ZM132.67,35.77c0,.89-.81,2.07-2.15,2.07s-2.15-1.18-2.15-2.07v-3.5h4.29v3.5h0Z"
                            />
                            <path
                                className="st3"
                                d="M128.13,31.95h0l-.03-.33s.08-.04.08-.08c0-.05-.04-.08-.08-.08h0v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.01.02h.04v.15h-.1l-.02-.32h.03s.01,0,.01-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.01.02.02h.02l-.02.32h-.09v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.03v.15h-.01s-.08.03-.08.08c0,.04.03.08.08.08l-.03.33h-.02s-.08.04-.08.08.04.08.08.08h.94s.08-.04.08-.08-.04-.08-.08-.08h-.02ZM127.44,31.95c0-.28.22-.34.22-.34h0s.21.06.22.34h-.44Z"
                            />
                            <path
                                className="st3"
                                d="M131.01,31.95h-.02l-.03-.33s.08-.04.08-.08c0-.05-.04-.08-.08-.08h0v-.15h.03s0,0,0-.02v-.1h-.04v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.04v.15h-.1l-.02-.32h.02s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.01.02.02h.03l-.02.32h-.09v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.04v.15h-.02s-.08.03-.08.08c0,.04.03.08.08.08l-.03.33h0s-.08.04-.08.08.03.08.08.08h.94s.08-.04.08-.08-.04-.08-.08-.08h-.03ZM130.31,31.95c0-.28.22-.34.22-.34h0s.21.06.22.34h-.45,0Z"
                            />
                            <path
                                className="st3"
                                d="M133.85,31.95h-.02l-.03-.33s.08-.04.08-.08c0-.05-.04-.08-.08-.08h0v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.03v.15h-.1l-.02-.32h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.01.02.02h.02l-.02.32h-.09v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.04v.15h-.02s-.08.03-.08.08c0,.04.03.08.07.08l-.03.33h-.02s-.08.04-.08.08.04.08.08.08h.94s.08-.04.08-.08-.03-.08-.08-.08h0ZM133.16,31.95c0-.28.22-.34.22-.34h0s.21.06.22.34h-.45,0Z"
                            />
                            <path
                                className="st3"
                                d="M128.13,34.91h0l-.03-.33s.08-.04.08-.08c0-.05-.04-.08-.08-.08h0v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.01.02h.04v.15h-.1l-.02-.32h.03s.01,0,.01-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.02l-.02.32h-.09v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.03v.15h-.01s-.08.04-.08.08.03.07.08.08l-.03.33h-.02s-.08.03-.08.08c0,.04.04.08.08.08h.94s.08-.03.08-.08-.04-.08-.08-.08h-.02ZM127.44,34.91c0-.28.22-.34.22-.34h0s.21.06.22.34h-.44Z"
                            />
                            <path
                                className="st3"
                                d="M133.85,34.91h-.02l-.03-.33s.08-.04.08-.08c0-.05-.04-.08-.08-.08h0v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.03v.15h-.1l-.02-.32h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.02l-.02.32h-.09v-.15h.03s.02,0,.02-.02v-.1h-.05v.05h-.07v-.05h-.05v.05h-.07v-.05h-.05v.1s0,.02.02.02h.04v.15h-.02s-.08.04-.08.08.03.07.07.08l-.03.33h-.02s-.08.03-.08.08c0,.04.04.08.08.08h.94s.08-.03.08-.08-.03-.08-.08-.08h0ZM133.16,34.91c0-.28.22-.34.22-.34h0s.21.06.22.34h-.45,0Z"
                            />
                            <path
                                className="st3"
                                d="M128.96,37.5h0l-.25-.2s.03-.08,0-.11-.09-.03-.12,0h0l-.11-.09h0l.02-.03v-.02l-.07-.07-.03.03.04.04-.05.05-.04-.04-.04.03.04.04-.05.05-.03-.04-.04.03.07.07h.03l.02-.02h0l.1.1-.06.06-.24-.21.02-.02v-.02l-.07-.07-.04.03.04.04-.05.05-.04-.04-.04.04.04.03-.05.05-.04-.04-.03.03.07.07h.02l.02-.02.21.24-.06.07-.11-.09h0l.02-.02v-.02l-.08-.07-.03.03.04.03-.05.05-.04-.04-.04.04.04.04-.05.05-.04-.03-.03.03.07.07h.02l.02-.02h0l.1.1h0s-.03.09,0,.12c.03.03.08.03.11,0l.21.25h0s-.03.09,0,.13c.03.03.09.03.12,0l.67-.67s.03-.08,0-.11c-.03-.04-.09-.04-.12,0v.02ZM128.47,37.99c-.19-.2-.08-.4-.08-.4h0s.2-.11.4.08l-.32.32h0Z"
                            />
                            <path
                                className="st3"
                                d="M132,37.5s-.03.08,0,.11l.67.67s.08.03.12,0c.03-.03.03-.08,0-.11h0l.21-.27s.08.02.11,0c.03-.03.03-.08,0-.12h0l.09-.11h0l.02.02h.02l.07-.07-.03-.03-.04.03-.05-.05.03-.04-.03-.04-.04.04-.05-.05.04-.03-.03-.03-.07.07v.02l.02.02h0l-.11.1-.06-.07.21-.24.02.02h.02l.07-.07-.03-.03-.04.04-.05-.05.04-.03-.04-.04-.03.04-.05-.05.04-.04-.03-.03-.07.07v.02l.02.02-.24.21-.06-.06.1-.11h0l.02.03h.02l.08-.07-.04-.03-.04.04-.05-.05.04-.04-.04-.03-.04.04-.05-.05.04-.04-.04-.03-.07.07v.02l.02.02h0l-.11.1h0s-.09-.04-.12,0c-.03.03-.03.08,0,.11l-.25.21h0s-.08-.05-.12,0v-.03ZM132.29,37.67c.2-.19.39-.08.4-.08h0s.1.19-.08.4l-.32-.32h0Z"
                            />
                            <path
                                className="st19"
                                d="M130.78,36.76c-.05,0-.09.05-.09.09,0,.06.04.1.09.1s.09-.04.09-.1c0-.05-.04-.09-.09-.09"
                            />
                            <path
                                className="st19"
                                d="M130.27,36.76s-.09.04-.09.09.05.09.09.09c.06,0,.1-.04.1-.09s-.04-.09-.1-.09"
                            />
                            <path
                                className="st154"
                                d="M130.52,33.99c.21,0,.48-.17.48-.51v-.68h-.95v.68c0,.34.27.51.48.51h0Z"
                            />
                            <path
                                className="st19"
                                d="M130.38,33.07c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.63,33.32c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.87,33.56c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.76,33.18c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.27,33.67c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st154"
                                d="M130.52,35.64c.21,0,.48-.17.48-.51v-.68h-.95v.68c0,.34.27.51.48.51h0Z"
                            />
                            <path
                                className="st19"
                                d="M130.38,34.72c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.63,34.96c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.87,35.21c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.76,34.83c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.27,35.31c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st154"
                                d="M129.2,35.64c.21,0,.48-.17.48-.51v-.68h-.95v.68c0,.34.27.51.48.51h0Z"
                            />
                            <path
                                className="st19"
                                d="M129.07,34.72c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M129.31,34.96c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M129.55,35.21c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M129.45,34.83c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st19"
                                d="M128.96,35.31c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st154"
                                d="M131.83,35.64c.21,0,.48-.17.48-.51v-.68h-.95v.68c0,.34.27.51.47.51Z"
                            />
                            <path
                                className="st19"
                                d="M131.7,34.72c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M131.94,34.96c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M132.19,35.21c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M132.08,34.83c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st19"
                                d="M131.59,35.31c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st154"
                                d="M130.52,37.28c.21,0,.48-.17.48-.51v-.68h-.95v.68c0,.34.27.51.48.51h0Z"
                            />
                            <path
                                className="st19"
                                d="M130.38,36.36c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.63,36.61c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.87,36.85c0-.06-.05-.11-.11-.11s-.11.05-.11.11.05.11.11.11.11-.05.11-.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.76,36.47c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st19"
                                d="M130.27,36.96c.06,0,.11-.05.11-.11s-.05-.11-.11-.11-.11.05-.11.11.05.11.11.11Z"
                            />
                            <path
                                className="st34"
                                d="M155.4,35.38l-2.34-3.75h-.22v2.73c.32.03.61.08.89.15v.86h-3.39v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.64c-.2-.02-.39-.04-.58-.06-.19-.03-.37-.06-.54-.1v-.85h1.37c.16,0,.35-.01.57-.02.22,0,.45-.01.71-.02h.78c.44,0,.85.04,1.23.13.37.09.69.22.96.4s.48.43.62.73c.15.3.22.66.22,1.09,0,.33-.06.62-.17.89-.11.27-.27.5-.47.71-.21.2-.45.37-.73.5s-.58.22-.92.28c.09.11.18.23.27.35.08.12.16.25.24.37l1.5,2.25c.14.02.28.04.44.06.15.03.32.06.49.09v.87h-2.05ZM154.89,28.13c-.29-.21-.73-.32-1.32-.32h-.39c-.12,0-.24.01-.34.02v2.75c.07,0,.16.02.27.02h.4c.56,0,1-.13,1.32-.39s.48-.61.48-1.05c0-.48-.14-.83-.43-1.04h0Z"
                            />
                            <path
                                className="st34"
                                d="M158.04,35.38v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.65c-.2-.02-.39-.04-.58-.06-.19-.03-.37-.06-.54-.1v-.84h5.74v2.07h-1.01c-.03-.18-.06-.35-.09-.52s-.05-.32-.06-.46h-2.07v2.61h1.66c.02-.15.04-.28.06-.42.03-.13.06-.26.1-.38h.87v2.62h-.87c-.04-.12-.08-.25-.1-.39s-.05-.28-.06-.4h-1.66v2.81h2.08c.02-.15.04-.32.06-.49s.06-.35.1-.54h1.01v2.16h-5.76Z"
                            />
                            <path
                                className="st34"
                                d="M171.14,30.44c-.16.36-.39.67-.68.93-.3.26-.65.47-1.07.62-.42.15-.87.22-1.38.22h-.31c-.11,0-.22,0-.33-.03v2.18c.2.02.39.04.58.06.19.03.37.06.54.1v.85h-3.62v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.64c-.2-.02-.39-.04-.58-.06-.19-.03-.37-.06-.54-.1v-.85h1.4c.18,0,.37-.01.58-.02.21,0,.44-.01.67-.02h.68c1.04,0,1.82.23,2.37.7.54.47.81,1.1.81,1.91,0,.42-.08.81-.24,1.17h0ZM169.49,28.22c-.3-.28-.76-.42-1.39-.42h-.37c-.11,0-.23,0-.35.03v3.17c.1.02.21.03.31.04.1,0,.21.01.31.01.59,0,1.06-.16,1.41-.46s.53-.7.53-1.21-.15-.88-.44-1.16h0Z"
                            />
                            <path
                                className="st34"
                                d="M179.58,27.73v4.34c0,1.16-.3,2.03-.89,2.59s-1.47.85-2.61.85c-.68,0-1.24-.09-1.67-.26s-.76-.4-1-.69c-.24-.29-.4-.61-.49-.98-.09-.37-.13-.75-.13-1.15v-4.7c-.15-.02-.29-.04-.44-.06-.15-.03-.28-.06-.41-.09v-.86h3.21v.86c-.15.04-.31.08-.48.1s-.33.04-.49.06v4.59c0,.29.03.56.08.81.06.25.16.46.3.64.15.18.35.32.61.42s.59.15.99.15c.35,0,.65-.04.91-.12.26-.08.47-.2.64-.38s.29-.4.37-.69c.08-.28.12-.62.12-1.03v-4.41c-.16-.02-.33-.04-.5-.06-.17-.02-.33-.05-.47-.1v-.86h3.21v.86c-.27.07-.56.12-.85.15v.02ZM175.96,26.1l-.51-.78,2.01-1.41.62.94-2.12,1.26h0Z"
                            />
                            <path
                                className="st34"
                                d="M188.01,33.65c-.11.31-.29.6-.55.86s-.6.48-1.04.65c-.44.17-.99.26-1.66.26-.27,0-.6,0-1.01-.02s-.86-.02-1.33-.02h-1.12v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.64c-.2-.02-.39-.04-.58-.06-.19-.03-.37-.06-.54-.1v-.85h1.08c.33,0,.73,0,1.23-.02.49-.01,1-.02,1.52-.02.95,0,1.66.18,2.14.55.48.37.72.89.72,1.55,0,.44-.13.85-.4,1.21s-.63.62-1.07.77v.03c.28.05.53.14.74.27.21.13.38.28.51.46.13.18.23.38.3.59s.1.43.1.65c0,.28-.05.58-.16.89h0ZM186.45,28.51c-.05-.15-.14-.27-.27-.38-.13-.11-.3-.19-.51-.25-.21-.06-.47-.09-.78-.09h-.56c-.18,0-.36.01-.53.02v2.57c.11,0,.23.01.35.01h.4c.65,0,1.14-.12,1.48-.37.33-.25.5-.59.5-1.03,0-.18-.03-.34-.08-.49h0ZM186.53,32.16c-.11-.17-.25-.31-.44-.42-.18-.11-.4-.18-.66-.23s-.54-.07-.85-.07h-.78v2.76c.24.04.58.06,1.01.06.64,0,1.11-.14,1.42-.42.3-.28.46-.64.46-1.07,0-.25-.05-.46-.16-.63v.02Z"
                            />
                            <path
                                className="st34"
                                d="M189.18,35.38v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.64c-.2-.02-.39-.04-.58-.06s-.37-.06-.54-.1v-.85h3.62v.85c-.17.04-.35.08-.54.1s-.38.05-.58.06v6.49h1.96c.04-.33.1-.71.18-1.12h1v2.27h-5.65,0Z"
                            />
                            <path
                                className="st34"
                                d="M195.33,35.38v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.64c-.2-.02-.39-.04-.58-.06s-.37-.06-.54-.1v-.85h3.62v.85c-.17.04-.35.08-.54.1s-.38.05-.58.06v6.64c.2.02.39.04.58.06.19.03.37.06.54.1v.85h-3.62Z"
                            />
                            <path
                                className="st34"
                                d="M205.13,29.15c-.04-.21-.07-.41-.1-.6-.02-.18-.04-.36-.06-.53-.2-.05-.38-.09-.56-.1-.18-.02-.36-.03-.55-.03-.42,0-.79.08-1.1.24-.31.16-.57.38-.78.65-.21.28-.37.61-.47,1s-.15.82-.15,1.28c0,.5.05.94.16,1.33.11.39.28.72.51.99s.53.47.89.62.79.21,1.3.21c.32,0,.66-.04,1.01-.11.35-.07.66-.17.93-.29l.09,1.28c-.36.12-.74.22-1.13.29s-.8.11-1.22.11c-1.36,0-2.38-.37-3.06-1.11s-1.02-1.77-1.02-3.09c0-.68.09-1.31.26-1.89.18-.57.44-1.07.8-1.48.35-.41.8-.73,1.35-.96.54-.23,1.19-.35,1.93-.35.33,0,.66.02,1,.06.34.04.68.1,1.01.18v2.28h-1.04v.02Z"
                            />
                            <path
                                className="st34"
                                d="M212.4,35.38v-.85c.15-.03.3-.06.47-.09s.34-.05.5-.06l-.45-1.22h-3.43l-.44,1.22c.16.02.33.04.5.06.17.03.33.06.47.09v.85h-3.12v-.85c.11-.03.23-.06.37-.08.13-.02.26-.04.38-.06l2.76-7.67h1.68l2.8,7.67c.12.02.25.04.38.06s.25.05.37.08v.85h-3.25,0ZM211.6,29.45c-.09-.22-.16-.44-.22-.65s-.12-.44-.17-.68h-.03c-.04.22-.1.45-.17.68-.07.23-.15.46-.23.69l-.94,2.58h2.71l-.96-2.62h0Z"
                            />
                            <path
                                className="st34"
                                d="M156.63,42.78c-.16.36-.39.67-.68.93-.3.26-.65.47-1.07.62-.42.15-.87.22-1.38.22h-.31c-.11,0-.22,0-.33-.03v2.18c.2.02.39.04.58.06.19.03.37.06.54.1v.85h-3.62v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.64c-.2-.02-.39-.04-.58-.06-.19-.03-.37-.06-.54-.1v-.85h1.4c.18,0,.37,0,.58-.02.21,0,.44,0,.67-.02h.68c1.04,0,1.82.23,2.37.7.54.47.81,1.1.81,1.91,0,.42-.08.81-.24,1.17h0ZM154.97,40.56c-.3-.28-.76-.42-1.39-.42h-.37c-.11,0-.23,0-.35.03v3.17c.1.02.21.03.31.04.1,0,.21,0,.31,0,.59,0,1.06-.16,1.41-.46s.53-.7.53-1.21-.15-.88-.44-1.16h0Z"
                            />
                            <path
                                className="st34"
                                d="M165.3,45.2c-.22.56-.52,1.04-.89,1.44-.38.39-.82.69-1.32.9-.5.21-1.04.31-1.62.31-.66,0-1.23-.1-1.72-.31-.49-.21-.89-.5-1.22-.88s-.57-.84-.73-1.37c-.16-.53-.24-1.14-.24-1.8,0-.72.11-1.36.33-1.93.22-.56.52-1.04.89-1.43.38-.39.82-.69,1.32-.89.5-.21,1.04-.31,1.62-.31s1.11.09,1.59.27.89.45,1.23.82c.34.36.61.82.8,1.36s.28,1.18.28,1.91-.11,1.36-.33,1.93v-.02ZM163.49,40.99c-.44-.56-1.07-.84-1.89-.84-.34,0-.66.07-.97.2s-.58.33-.81.6-.42.6-.56.99c-.14.39-.21.85-.21,1.38,0,.49.05.94.15,1.34s.26.75.46,1.04c.21.29.47.51.79.67.32.16.69.24,1.12.24.32,0,.63-.06.94-.19.31-.13.59-.33.83-.59s.44-.6.59-1,.22-.87.22-1.41c0-1.05-.22-1.86-.66-2.42h0Z"
                            />
                            <path
                                className="st34"
                                d="M171.51,47.72l-2.34-3.75h-.22v2.73c.32.03.61.08.89.15v.86h-3.39v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.64c-.2-.02-.39-.04-.58-.06-.19-.03-.37-.06-.54-.1v-.85h1.37c.16,0,.35,0,.57-.02.22,0,.45,0,.71-.02h.78c.44,0,.85.04,1.23.13.37.09.69.22.96.4s.48.43.62.73c.15.3.22.66.22,1.09,0,.33-.06.62-.17.89s-.27.5-.47.71c-.21.2-.45.37-.73.5s-.58.22-.92.28c.09.11.18.23.27.35.08.12.16.25.24.37l1.5,2.25c.14.02.28.04.44.06.15.03.32.06.49.09v.87h-2.05ZM171,40.47c-.29-.21-.73-.32-1.32-.32h-.39c-.12,0-.24,0-.34.02v2.75c.07,0,.16.02.27.02h.4c.56,0,1-.13,1.32-.39s.48-.61.48-1.05c0-.48-.14-.83-.43-1.04h0Z"
                            />
                            <path
                                className="st34"
                                d="M179.91,41.35c-.04-.22-.08-.43-.11-.62s-.05-.36-.07-.53h-1.57v6.5c.2.02.39.04.58.06.19.03.37.06.54.1v.85h-3.62v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.5h-1.58c-.02.16-.04.34-.06.53-.03.19-.06.39-.1.62h-1v-2.3h6.88v2.3h-1.01Z"
                            />
                            <path
                                className="st34"
                                d="M189.14,40.07v4.34c0,1.16-.3,2.03-.89,2.59s-1.47.85-2.61.85c-.68,0-1.24-.09-1.67-.26s-.76-.4-1-.69c-.24-.29-.4-.61-.49-.98-.09-.37-.13-.75-.13-1.15v-4.7c-.15-.02-.29-.04-.44-.06-.15-.03-.28-.06-.41-.09v-.86h3.21v.86c-.15.04-.31.07-.48.1s-.33.04-.49.06v4.59c0,.29.03.56.08.81.06.25.16.46.3.64.15.18.35.32.61.42s.59.15.99.15c.35,0,.65-.04.91-.12.26-.08.47-.2.64-.38s.29-.4.37-.69c.08-.28.12-.62.12-1.03v-4.41c-.16-.02-.33-.04-.5-.06s-.33-.05-.47-.1v-.86h3.21v.86c-.27.07-.56.12-.85.15v.02Z"
                            />
                            <path
                                className="st34"
                                d="M198.47,44.2c-.13.02-.27.04-.4.06v3.07c-.44.17-.91.3-1.41.39s-1.01.13-1.5.13c-.67,0-1.27-.1-1.8-.3s-.99-.48-1.36-.84-.66-.81-.86-1.34-.3-1.13-.3-1.8.11-1.3.33-1.87.53-1.06.94-1.47.9-.73,1.49-.96c.58-.23,1.24-.34,1.98-.34.4,0,.8.03,1.19.08s.79.13,1.19.23v2.18h-1.04c-.04-.2-.08-.39-.1-.57-.03-.18-.05-.36-.06-.53-.21-.05-.43-.09-.64-.12s-.42-.04-.63-.04c-.44,0-.85.07-1.22.2-.38.14-.71.34-.99.62s-.51.62-.67,1.03-.24.88-.24,1.42c0,1.01.27,1.79.8,2.34.54.55,1.27.83,2.21.83.25,0,.48-.02.71-.05.22-.03.43-.09.63-.15v-2.13c-.2-.02-.39-.04-.58-.06-.19-.03-.36-.06-.51-.1v-.85h3.26v.86c-.12.03-.25.06-.38.08h-.04Z"
                            />
                            <path
                                className="st34"
                                d="M207.16,40.07v4.34c0,1.16-.3,2.03-.89,2.59s-1.47.85-2.61.85c-.68,0-1.24-.09-1.67-.26s-.76-.4-1-.69c-.24-.29-.4-.61-.49-.98-.09-.37-.13-.75-.13-1.15v-4.7c-.15-.02-.29-.04-.44-.06-.15-.03-.28-.06-.41-.09v-.86h3.21v.86c-.15.04-.31.07-.48.1-.17.02-.33.04-.49.06v4.59c0,.29.03.56.08.81s.16.46.3.64c.15.18.35.32.61.42s.59.15.99.15c.35,0,.65-.04.91-.12.26-.08.47-.2.64-.38s.29-.4.37-.69c.08-.28.12-.62.12-1.03v-4.41c-.16-.02-.33-.04-.5-.06s-.33-.05-.48-.1v-.86h3.21v.86c-.27.07-.56.12-.85.15v.02Z"
                            />
                            <path
                                className="st34"
                                d="M208.88,47.72v-.85c.17-.04.35-.08.54-.1.19-.03.38-.05.58-.06v-6.65c-.2-.02-.39-.04-.58-.06-.19-.03-.37-.06-.54-.1v-.84h5.74v2.07h-1.01c-.03-.18-.06-.35-.09-.52-.03-.17-.05-.32-.06-.46h-2.07v2.61h1.66c.02-.15.04-.28.06-.42.03-.13.06-.26.1-.38h.87v2.62h-.87c-.04-.12-.08-.25-.1-.39-.03-.14-.05-.28-.06-.4h-1.66v2.81h2.08c.02-.15.04-.32.06-.49.03-.17.06-.35.1-.54h1.01v2.16h-5.76Z"
                            />
                            <path
                                className="st34"
                                d="M221.08,46.2c-.15.33-.37.62-.65.87-.28.24-.63.43-1.03.57-.41.14-.86.21-1.37.21-.7,0-1.33-.07-1.9-.22v-2.18h1.03c.03.2.06.39.09.57s.05.36.06.52c.12.03.25.05.39.06.14.02.27.03.38.03.25,0,.48-.03.69-.08s.4-.13.56-.24.28-.25.37-.42.13-.37.13-.6c0-.3-.1-.54-.29-.72-.19-.18-.43-.33-.71-.46-.28-.13-.59-.25-.93-.37s-.65-.27-.93-.45c-.28-.19-.52-.42-.71-.71s-.29-.66-.29-1.13c0-.37.07-.71.21-1.02s.35-.58.62-.8c.27-.22.6-.39.99-.52.39-.12.83-.19,1.33-.19.31,0,.6.02.88.04.28.03.56.08.85.13v2.09h-1.03c-.04-.19-.07-.37-.1-.55-.02-.18-.04-.35-.06-.5-.07-.02-.16-.03-.27-.05-.11,0-.22-.02-.33-.02-.54,0-.95.11-1.22.34s-.4.52-.4.88c0,.29.1.52.29.7.19.18.43.33.72.46.29.13.59.25.93.38.33.12.64.28.93.46s.52.42.72.7c.19.28.29.65.29,1.1,0,.4-.08.77-.23,1.1v.02Z"
                            />
                            <path
                                className="st34"
                                d="M227.24,47.72v-.85c.15-.03.3-.06.47-.09s.34-.05.5-.06l-.45-1.22h-3.43l-.44,1.22c.16.02.33.04.5.06.17.03.33.06.47.09v.85h-3.12v-.85c.11-.03.23-.06.37-.08s.26-.04.38-.06l2.76-7.67h1.68l2.8,7.67c.12.02.25.04.38.06s.25.05.37.08v.85h-3.25,0ZM226.45,41.79c-.09-.22-.16-.44-.22-.65-.06-.21-.12-.44-.17-.68h-.03c-.04.22-.1.45-.17.68-.07.23-.15.46-.23.69l-.94,2.58h2.71l-.96-2.62h0Z"
                            />
                        </g>
                        <g>
                            <rect
                                className="st41"
                                x="247.73"
                                y="20.72"
                                width="45.55"
                                height="30.93"
                            />
                            <rect
                                className="st42"
                                x="248.6"
                                y="21.57"
                                width="43.8"
                                height="29.2"
                            />
                            <polyline
                                className="st139"
                                points="269.57 27.93 270.49 27.26 271.42 27.93 271.07 26.84 272 26.17 270.85 26.17 270.49 25.06 270.14 26.17 268.98 26.17 269.92 26.84 269.57 27.93"
                            />
                            <polyline
                                className="st139"
                                points="264.79 29.22 265.71 28.54 266.63 29.22 266.28 28.13 267.22 27.45 266.06 27.45 265.71 26.35 265.36 27.45 264.2 27.45 265.14 28.13 264.79 29.22"
                            />
                            <polyline
                                className="st139"
                                points="262.21 29.86 261.86 30.96 260.7 30.96 261.64 31.63 261.29 32.73 262.21 32.05 263.14 32.73 262.78 31.63 263.72 30.96 262.57 30.96 262.21 29.86"
                            />
                            <polyline
                                className="st139"
                                points="260.93 36.83 261.85 37.5 261.5 36.41 262.44 35.74 261.28 35.74 260.93 34.63 260.57 35.74 259.42 35.74 260.36 36.41 260 37.5 260.93 36.83"
                            />
                            <polyline
                                className="st139"
                                points="262.57 40.53 262.21 39.42 261.86 40.53 260.7 40.53 261.64 41.2 261.29 42.29 262.21 41.62 263.14 42.29 262.78 41.2 263.72 40.53 262.57 40.53"
                            />
                            <polyline
                                className="st139"
                                points="266.07 44.03 265.72 42.93 265.36 44.03 264.21 44.03 265.14 44.71 264.79 45.8 265.72 45.12 266.64 45.8 266.29 44.71 267.23 44.03 266.07 44.03"
                            />
                            <polyline
                                className="st139"
                                points="270.85 45.3 270.49 44.2 270.14 45.31 268.98 45.3 269.92 45.98 269.57 47.07 270.49 46.39 271.42 47.07 271.07 45.98 272 45.3 270.85 45.3"
                            />
                            <polyline
                                className="st139"
                                points="275.62 44.03 275.27 42.93 274.92 44.03 273.76 44.03 274.7 44.71 274.35 45.8 275.27 45.12 276.19 45.8 275.84 44.71 276.78 44.03 275.62 44.03"
                            />
                            <polyline
                                className="st139"
                                points="279.13 40.53 278.78 39.42 278.42 40.53 277.27 40.53 278.2 41.2 277.85 42.29 278.78 41.62 279.7 42.29 279.35 41.2 280.29 40.53 279.13 40.53"
                            />
                            <polyline
                                className="st139"
                                points="281.56 35.72 280.4 35.72 280.05 34.62 279.69 35.72 278.54 35.72 279.47 36.4 279.12 37.49 280.05 36.81 280.97 37.49 280.62 36.4 281.56 35.72"
                            />
                            <polyline
                                className="st139"
                                points="277.85 32.71 278.78 32.04 279.7 32.71 279.35 31.62 280.29 30.95 279.13 30.95 278.78 29.84 278.42 30.95 277.27 30.95 278.2 31.62 277.85 32.71"
                            />
                            <polyline
                                className="st139"
                                points="275.28 26.35 274.93 27.46 273.77 27.45 274.71 28.13 274.36 29.22 275.29 28.54 276.21 29.22 275.86 28.13 276.8 27.45 275.64 27.45 275.28 26.35"
                            />
                            <path
                                className="st42"
                                d="M297.82,28.09v-6.52h4.47v1.1h-3.15v1.54h2.72v1.1h-2.72v2.77h-1.32Z"
                            />
                            <path
                                className="st42"
                                d="M303.37,22.73v-1.16h1.25v1.16h-1.25ZM303.37,28.09v-4.72h1.25v4.72h-1.25Z"
                            />
                            <path
                                className="st42"
                                d="M310.2,28.09h-1.25v-2.41c0-.51-.03-.84-.08-.99s-.14-.27-.26-.35-.26-.12-.43-.12c-.22,0-.41.06-.58.18-.17.12-.29.28-.35.47s-.1.56-.1,1.09v2.14h-1.25v-4.72h1.16v.69c.41-.53.93-.8,1.56-.8.28,0,.53.05.76.15s.4.23.52.38.2.33.24.52.07.48.07.84v2.94h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M312.4,24.81l-1.13-.2c.13-.46.35-.79.66-1.01s.77-.33,1.39-.33c.56,0,.97.07,1.25.2.27.13.46.3.58.5.11.2.17.58.17,1.12v1.46c-.01.42,0,.72.05.92.04.2.11.41.22.63h-1.24c-.03-.08-.07-.21-.12-.37-.02-.07-.04-.12-.04-.15-.21.21-.44.36-.68.47-.24.1-.5.16-.78.16-.49,0-.87-.13-1.15-.4-.28-.26-.42-.6-.42-1,0-.27.06-.5.19-.71s.31-.37.54-.48c.23-.11.56-.21.99-.29.58-.11.99-.21,1.21-.31v-.12c0-.24-.06-.41-.18-.51s-.34-.15-.67-.15c-.22,0-.4.04-.52.13s-.23.24-.3.46l-.02-.02ZM314.07,25.82c-.16.05-.41.12-.76.19s-.57.15-.68.22c-.16.12-.24.26-.24.44s.07.33.2.45c.13.13.3.19.5.19.23,0,.44-.07.64-.22.15-.11.25-.25.3-.41.03-.11.05-.31.05-.61v-.25h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M320.83,28.09h-1.25v-2.41c0-.51-.03-.84-.08-.99s-.14-.27-.26-.35-.26-.12-.43-.12c-.22,0-.41.06-.58.18-.17.12-.29.28-.35.47s-.1.56-.1,1.09v2.14h-1.25v-4.72h1.16v.69c.41-.53.93-.8,1.56-.8.28,0,.53.05.76.15s.4.23.52.38.2.33.24.52.07.48.07.84v2.94h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M326.22,24.76l-1.23.22c-.04-.25-.14-.43-.28-.56-.15-.12-.34-.19-.57-.19-.31,0-.56.11-.75.32-.19.22-.28.57-.28,1.08,0,.56.09.96.28,1.19s.44.35.76.35c.24,0,.43-.07.58-.2.15-.13.26-.37.32-.7l1.23.21c-.13.56-.37.99-.73,1.28-.36.29-.85.43-1.45.43-.69,0-1.24-.22-1.65-.65s-.62-1.04-.62-1.81.21-1.39.62-1.82.97-.65,1.67-.65c.58,0,1.03.12,1.37.37s.58.63.73,1.13Z"
                            />
                            <path
                                className="st42"
                                d="M327.17,22.73v-1.16h1.25v1.16h-1.25ZM327.17,28.09v-4.72h1.25v4.72h-1.25Z"
                            />
                            <path
                                className="st42"
                                d="M330.63,24.81l-1.13-.2c.13-.46.35-.79.66-1.01s.77-.33,1.39-.33c.56,0,.97.07,1.25.2.27.13.46.3.58.5.11.2.17.58.17,1.12v1.46c-.01.42,0,.72.05.92.04.2.11.41.22.63h-1.24c-.03-.08-.07-.21-.12-.37-.02-.07-.04-.12-.04-.15-.21.21-.44.36-.68.47-.24.1-.5.16-.78.16-.49,0-.87-.13-1.15-.4-.28-.26-.42-.6-.42-1,0-.27.06-.5.19-.71s.31-.37.54-.48c.23-.11.56-.21.99-.29.58-.11.99-.21,1.21-.31v-.12c0-.24-.06-.41-.18-.51s-.34-.15-.67-.15c-.22,0-.4.04-.52.13s-.23.24-.3.46l-.02-.02ZM332.3,25.82c-.16.05-.41.12-.76.19s-.57.15-.68.22c-.16.12-.24.26-.24.44s.07.33.2.45c.13.13.3.19.5.19.23,0,.44-.07.64-.22.15-.11.25-.25.3-.41.03-.11.05-.31.05-.61v-.25h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M339.1,28.09h-1.16v-.69c-.19.27-.42.47-.68.6-.26.13-.53.2-.79.2-.54,0-1.01-.22-1.39-.66-.39-.44-.58-1.05-.58-1.83s.19-1.41.56-1.83c.38-.42.85-.63,1.43-.63.53,0,.98.22,1.37.66v-2.35h1.25v6.52h0ZM335.76,25.63c0,.5.07.87.21,1.09.2.33.48.49.85.49.29,0,.53-.12.73-.37.2-.24.3-.61.3-1.1,0-.54-.1-.93-.29-1.17-.2-.24-.45-.36-.75-.36s-.55.12-.75.35c-.2.24-.3.59-.3,1.06h0Z"
                            />
                            <path
                                className="st42"
                                d="M340.04,25.66c0-.42.1-.82.31-1.21.2-.39.49-.69.87-.89.38-.2.79-.31,1.26-.31.71,0,1.3.23,1.76.7.46.46.69,1.05.69,1.76s-.23,1.31-.69,1.78c-.46.47-1.04.71-1.74.71-.43,0-.85-.1-1.24-.29-.39-.2-.69-.48-.9-.86-.2-.38-.31-.84-.31-1.38h-.01ZM341.32,25.73c0,.47.11.83.33,1.08s.5.37.82.37.6-.12.82-.37.33-.61.33-1.09-.11-.82-.33-1.07-.49-.37-.82-.37-.6.12-.82.37-.33.61-.33,1.08Z"
                            />
                            <path
                                className="st42"
                                d="M348.39,23.37h1.17v.69c.15-.24.36-.43.61-.58.26-.15.54-.22.86-.22.55,0,1.01.22,1.4.65.38.43.57,1.03.57,1.8s-.19,1.4-.58,1.84c-.39.44-.85.66-1.4.66-.26,0-.5-.05-.71-.16-.21-.1-.44-.28-.67-.53v2.38h-1.25v-6.52h0ZM349.63,25.65c0,.53.11.92.32,1.18.21.25.47.38.77.38s.53-.12.73-.35c.19-.23.29-.61.29-1.15,0-.5-.1-.86-.3-1.1-.2-.24-.44-.36-.74-.36s-.56.12-.76.35c-.2.24-.3.59-.3,1.05h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M356.73,26.59l1.25.21c-.16.46-.41.8-.76,1.04-.35.24-.78.36-1.3.36-.82,0-1.43-.27-1.82-.81-.31-.43-.47-.97-.47-1.63,0-.78.2-1.4.61-1.84.41-.44.93-.67,1.55-.67.7,0,1.26.23,1.66.7.41.46.6,1.18.58,2.13h-3.13c0,.37.11.66.3.87.19.21.43.31.72.31.2,0,.36-.05.49-.16s.23-.28.3-.52h.02ZM356.8,25.32c0-.36-.1-.64-.28-.83s-.39-.28-.65-.28-.5.1-.68.3c-.18.2-.27.47-.26.81,0,0,1.87,0,1.87,0Z"
                            />
                            <path
                                className="st42"
                                d="M359.06,28.09v-6.52h1.25v6.52h-1.25Z"
                            />
                            <path
                                className="st42"
                                d="M362.52,24.81l-1.13-.2c.13-.46.35-.79.66-1.01s.77-.33,1.39-.33c.56,0,.97.07,1.25.2.27.13.46.3.58.5.11.2.17.58.17,1.12v1.46c-.01.42,0,.72.05.92.04.2.11.41.22.63h-1.24c-.03-.08-.07-.21-.12-.37-.02-.07-.04-.12-.04-.15-.21.21-.44.36-.68.47-.24.1-.5.16-.78.16-.49,0-.87-.13-1.15-.4-.28-.26-.42-.6-.42-1,0-.27.06-.5.19-.71s.31-.37.54-.48c.23-.11.56-.21.99-.29.58-.11.99-.21,1.21-.31v-.12c0-.24-.06-.41-.18-.51s-.34-.15-.67-.15c-.22,0-.4.04-.52.13s-.23.24-.3.46l-.02-.02ZM364.2,25.82c-.16.05-.41.12-.76.19s-.57.15-.68.22c-.16.12-.24.26-.24.44s.07.33.2.45c.13.13.3.19.5.19.23,0,.44-.07.64-.22.15-.11.25-.25.3-.41.03-.11.05-.31.05-.61v-.25h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M297.8,32.5h1.32v3.53c0,.56.02.92.05,1.09.06.27.19.48.4.64s.5.24.87.24.66-.08.85-.23c.19-.15.3-.34.34-.56s.06-.59.06-1.11v-3.61h1.32v3.43c0,.78-.04,1.34-.11,1.66-.07.32-.2.6-.39.82s-.45.4-.77.53c-.32.13-.74.2-1.25.2-.62,0-1.1-.07-1.42-.22-.32-.14-.58-.33-.76-.56-.19-.23-.31-.47-.37-.72-.09-.37-.13-.93-.13-1.65v-3.48h0Z"
                            />
                            <path
                                className="st42"
                                d="M308.68,39.03h-1.25v-2.41c0-.51-.03-.84-.08-.99s-.14-.27-.26-.35c-.12-.08-.26-.12-.43-.12-.22,0-.41.06-.58.18-.17.12-.29.28-.35.47s-.1.56-.1,1.09v2.14h-1.25v-4.72h1.16v.69c.41-.53.93-.8,1.56-.8.28,0,.53.05.76.15.23.1.4.23.52.38s.2.33.24.52.07.48.07.84v2.94h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M309.95,33.66v-1.16h1.25v1.16h-1.25ZM309.95,39.03v-4.72h1.25v4.72h-1.25Z"
                            />
                            <path
                                className="st42"
                                d="M313.41,35.74l-1.13-.2c.13-.46.35-.79.66-1.01.31-.22.77-.33,1.39-.33.56,0,.97.07,1.25.2.27.13.46.3.58.5.11.2.17.58.17,1.12v1.46c-.01.42,0,.72.05.92.04.2.11.41.22.63h-1.24c-.03-.08-.07-.21-.12-.37-.02-.07-.04-.12-.04-.15-.21.21-.44.36-.68.47-.24.1-.5.16-.78.16-.49,0-.87-.13-1.15-.4-.28-.26-.42-.6-.42-1,0-.27.06-.5.19-.71s.31-.37.54-.48.56-.21.99-.29c.58-.11.99-.21,1.21-.31v-.12c0-.24-.06-.41-.18-.51s-.34-.15-.67-.15c-.22,0-.4.04-.52.13s-.23.24-.3.46l-.02-.02ZM313.41,33.66h-.57v-.16c0-.31.08-.55.23-.72.15-.17.35-.25.58-.25.1,0,.2,0,.29.03s.25.09.49.19c.24.11.42.16.55.16.1,0,.17-.03.24-.09.06-.06.1-.16.12-.3h.58c0,.4-.08.69-.22.86-.15.17-.34.26-.57.26-.1,0-.2,0-.3-.03-.07-.02-.24-.08-.51-.18-.27-.1-.47-.16-.6-.16-.1,0-.17.03-.22.09s-.08.16-.08.3h0ZM315.09,36.76c-.16.05-.41.12-.76.19s-.57.15-.68.22c-.16.12-.24.26-.24.44s.07.33.2.45c.13.13.3.19.5.19.23,0,.44-.07.64-.22.15-.11.25-.25.3-.41.03-.11.05-.31.05-.61v-.25h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M317.26,36.6c0-.42.1-.82.31-1.21.2-.39.49-.69.87-.89s.79-.31,1.26-.31c.71,0,1.3.23,1.76.7.46.46.69,1.05.69,1.76s-.23,1.31-.69,1.78c-.46.47-1.04.71-1.74.71-.43,0-.85-.1-1.24-.29-.39-.2-.69-.48-.9-.86-.2-.38-.31-.84-.31-1.38h-.01ZM318.54,36.66c0,.47.11.83.33,1.08s.5.37.82.37.6-.12.82-.37.33-.61.33-1.09-.11-.82-.33-1.07-.49-.37-.82-.37-.6.12-.82.37-.33.61-.33,1.08Z"
                            />
                            <path
                                className="st42"
                                d="M325.65,39.03v-6.52h4.84v1.1h-3.52v1.45h3.27v1.1h-3.27v1.77h3.64v1.1h-4.96Z"
                            />
                            <path
                                className="st42"
                                d="M334.83,39.03v-.71c-.17.25-.4.45-.68.6-.28.15-.58.22-.89.22s-.6-.07-.85-.21-.43-.34-.55-.59c-.11-.25-.17-.6-.17-1.05v-2.99h1.25v2.17c0,.66.02,1.07.07,1.22s.13.27.25.36.28.13.46.13c.21,0,.4-.06.57-.18s.28-.26.35-.44c.06-.17.09-.6.09-1.27v-1.99h1.25v4.72h-1.16.01Z"
                            />
                            <path
                                className="st42"
                                d="M338.48,39.03h-1.25v-4.72h1.16v.67c.2-.32.38-.53.54-.63.16-.1.34-.15.54-.15.28,0,.56.08.82.24l-.39,1.09c-.21-.14-.41-.2-.59-.2s-.32.05-.44.14c-.12.1-.22.27-.29.52s-.1.78-.1,1.58v1.46Z"
                            />
                            <path
                                className="st42"
                                d="M340.54,36.6c0-.42.1-.82.31-1.21.2-.39.49-.69.87-.89s.79-.31,1.26-.31c.71,0,1.3.23,1.76.7.46.46.69,1.05.69,1.76s-.23,1.31-.69,1.78c-.46.47-1.04.71-1.74.71-.43,0-.85-.1-1.24-.29-.39-.2-.69-.48-.9-.86-.2-.38-.31-.84-.31-1.38h-.01ZM341.82,36.66c0,.47.11.83.33,1.08s.5.37.82.37.6-.12.82-.37.33-.61.33-1.09-.11-.82-.33-1.07-.49-.37-.82-.37-.6.12-.82.37-.33.61-.33,1.08Z"
                            />
                            <path
                                className="st42"
                                d="M346.36,34.3h1.17v.69c.15-.24.36-.43.61-.58.26-.15.54-.22.86-.22.55,0,1.01.22,1.4.65.38.43.57,1.03.57,1.8s-.19,1.4-.58,1.84c-.39.44-.85.66-1.4.66-.26,0-.5-.05-.71-.16-.21-.1-.44-.28-.67-.53v2.38h-1.25v-6.52h0ZM347.6,36.58c0,.53.11.92.32,1.18.21.25.47.38.77.38s.53-.12.73-.35c.19-.23.29-.61.29-1.15,0-.5-.1-.86-.3-1.1-.2-.24-.44-.36-.74-.36s-.56.12-.76.35c-.2.24-.3.59-.3,1.05h-.01Z"
                            />
                            <path
                                className="st42"
                                d="M354.7,37.52l1.25.21c-.16.46-.41.8-.76,1.04s-.78.36-1.3.36c-.82,0-1.43-.27-1.82-.81-.31-.43-.47-.97-.47-1.63,0-.78.2-1.4.61-1.84.41-.44.93-.67,1.55-.67.7,0,1.26.23,1.66.7.41.46.6,1.18.58,2.13h-3.13c0,.37.11.66.3.87s.43.31.72.31c.2,0,.36-.05.49-.16s.23-.28.3-.52h.02ZM354.77,36.26c0-.36-.1-.64-.28-.83s-.39-.28-.65-.28-.5.1-.68.3-.27.47-.26.81h1.87Z"
                            />
                            <path
                                className="st42"
                                d="M357.03,33.66v-1.16h1.25v1.16h-1.25ZM357.03,39.03v-4.72h1.25v4.72h-1.25Z"
                            />
                            <path
                                className="st42"
                                d="M360.5,35.74l-1.13-.2c.13-.46.35-.79.66-1.01.31-.22.77-.33,1.39-.33.56,0,.97.07,1.25.2.27.13.46.3.58.5.11.2.17.58.17,1.12v1.46c-.01.42,0,.72.05.92.04.2.11.41.22.63h-1.24c-.03-.08-.07-.21-.12-.37-.02-.07-.04-.12-.04-.15-.21.21-.44.36-.68.47-.24.1-.5.16-.78.16-.49,0-.87-.13-1.15-.4-.28-.26-.42-.6-.42-1,0-.27.06-.5.19-.71s.31-.37.54-.48.56-.21.99-.29c.58-.11.99-.21,1.21-.31v-.12c0-.24-.06-.41-.18-.51s-.34-.15-.67-.15c-.22,0-.4.04-.52.13s-.23.24-.3.46l-.02-.02ZM362.17,36.76c-.16.05-.41.12-.76.19s-.57.15-.68.22c-.16.12-.24.26-.24.44s.07.33.2.45c.13.13.3.19.5.19.23,0,.44-.07.64-.22.15-.11.25-.25.3-.41.03-.11.05-.31.05-.61v-.25h-.01Z"
                            />
                            <text
                                className="st25"
                                transform="translate(297.22 50.76)"
                            >
                                <tspan x="0" y="0">
                                    NextGenerationEU
                                </tspan>
                            </text>
                        </g>
                        <g>
                            <path
                                className="st54"
                                d="M61.28,31.19c0,4.01-3.3,6.43-6.81,6.43h-2.92v5.18h-4.32v-18.03h7.24c3.5,0,6.81,2.41,6.81,6.43h0ZM56.96,31.19c0-1.47-1.07-2.36-2.49-2.36h-2.92v4.72h2.92c1.42,0,2.49-.89,2.49-2.36Z"
                            />
                            <path
                                className="st54"
                                d="M69.25,37.61h-2.13v5.18h-4.32v-18.03h7.24c3.5,0,6.81,2.41,6.81,6.43,0,2.57-1.35,4.5-3.25,5.54l3.5,6.07h-4.85l-3-5.18h0ZM67.12,33.55h2.92c1.42,0,2.49-.89,2.49-2.36s-1.07-2.36-2.49-2.36h-2.92v4.72Z"
                            />
                            <path
                                className="st54"
                                d="M85.59,37.61h-2.13v5.18h-4.32v-18.03h7.24c3.5,0,6.81,2.41,6.81,6.43,0,2.57-1.35,4.5-3.25,5.54l3.5,6.07h-4.85l-3-5.18h0ZM83.45,33.55h2.92c1.42,0,2.49-.89,2.49-2.36s-1.07-2.36-2.49-2.36h-2.92v4.72Z"
                            />
                            <path
                                className="st54"
                                d="M50,46.91c0,.73-.57,1.14-1.22,1.14h-.63v1.06h-.58v-3.33h1.21c.65,0,1.22.41,1.22,1.14h0ZM49.43,46.91c0-.39-.27-.59-.64-.59h-.63v1.18h.63c.37,0,.64-.2.64-.59Z"
                            />
                            <path
                                className="st54"
                                d="M51.29,49.11h-.58v-3.52h.58v3.52Z"
                            />
                            <path
                                className="st54"
                                d="M53.34,46.69c.41,0,.73.22.85.49l.03-.44h.55v2.37h-.55l-.03-.44c-.12.27-.44.49-.85.49-.68,0-1.18-.55-1.18-1.23s.5-1.23,1.18-1.23h0ZM53.43,48.61c.4,0,.69-.31.69-.69s-.29-.69-.69-.69-.7.31-.7.69.29.69.7.69Z"
                            />
                            <path
                                className="st54"
                                d="M58.06,47.71v1.4h-.58v-1.14c0-.55-.2-.74-.52-.74-.4,0-.64.31-.66.69v1.19h-.58v-2.37h.54l.03.35c.23-.23.53-.4.89-.4.57,0,.87.37.87,1.02h.01Z"
                            />
                            <path
                                className="st54"
                                d="M58.88,47.92c0-.68.53-1.23,1.28-1.23s1.27.55,1.27,1.23-.53,1.23-1.27,1.23-1.28-.55-1.28-1.23ZM60.85,47.92c0-.38-.29-.69-.69-.69s-.7.31-.7.69.29.69.7.69.69-.31.69-.69Z"
                            />
                            <path
                                className="st54"
                                d="M65.42,46.69c.41,0,.73.22.85.49v-1.59h.58v3.52h-.55l-.03-.44c-.12.27-.44.49-.85.49-.68,0-1.18-.55-1.18-1.23s.5-1.23,1.18-1.23h0ZM65.52,48.61c.4,0,.69-.31.69-.69s-.29-.69-.69-.69-.7.31-.7.69.29.69.7.69Z"
                            />
                            <path
                                className="st54"
                                d="M70.14,48.1h-1.8c.01.29.23.54.65.54.3,0,.49-.16.59-.32l.51.06c-.07.32-.44.78-1.1.78-.73,0-1.22-.55-1.22-1.25s.47-1.22,1.19-1.22,1.19.58,1.19,1.26v.15h-.01ZM68.34,47.7h1.22c-.02-.26-.25-.5-.61-.5s-.6.23-.61.5Z"
                            />
                            <path
                                className="st54"
                                d="M74.03,48.06h-.59v1.05h-.58v-3.33h1.25c.61,0,1.17.43,1.17,1.15,0,.51-.29.87-.67,1.04l.7,1.15h-.65l-.64-1.05h.01ZM73.45,47.52h.68c.32,0,.59-.23.59-.6s-.27-.6-.59-.6h-.68s0,1.2,0,1.2Z"
                            />
                            <path
                                className="st54"
                                d="M78.36,48.1h-1.8c.01.29.23.54.65.54.3,0,.49-.16.59-.32l.51.06c-.07.32-.44.78-1.1.78-.73,0-1.22-.55-1.22-1.25s.47-1.22,1.19-1.22,1.19.58,1.19,1.26v.15h-.01ZM76.56,47.7h1.22c-.02-.26-.25-.5-.61-.5s-.6.23-.61.5Z"
                            />
                            <path
                                className="st54"
                                d="M80.46,47.23c-.35,0-.7.28-.7.69s.35.69.7.69c.22,0,.42-.08.61-.25v.55c-.16.14-.39.24-.7.24-.7,0-1.22-.56-1.22-1.23s.52-1.23,1.22-1.23c.31,0,.54.1.7.24v.55c-.19-.18-.38-.25-.61-.25Z"
                            />
                            <path
                                className="st54"
                                d="M84.29,46.73v2.37h-.54l-.03-.35c-.23.23-.53.4-.89.4-.57,0-.87-.37-.87-1.02v-1.4h.58v1.14c0,.55.2.74.52.74.41,0,.66-.32.66-.72v-1.15h.58-.01Z"
                            />
                            <path
                                className="st54"
                                d="M85.25,46.73h.54l.03.44c.13-.27.44-.49.85-.49.68,0,1.18.55,1.18,1.23s-.5,1.23-1.18,1.23c-.41,0-.72-.22-.85-.49v1.52h-.58v-3.45h.01ZM86.58,48.61c.4,0,.69-.31.69-.69s-.29-.69-.69-.69-.69.31-.69.69.28.69.69.69Z"
                            />
                            <path
                                className="st54"
                                d="M90.98,48.1h-1.8c.01.29.23.54.65.54.3,0,.49-.16.59-.32l.51.06c-.07.32-.44.78-1.1.78-.73,0-1.22-.55-1.22-1.25s.47-1.22,1.19-1.22,1.19.58,1.19,1.26v.15h-.01ZM89.18,47.7h1.22c-.02-.26-.25-.5-.61-.5s-.6.23-.61.5Z"
                            />
                            <path
                                className="st54"
                                d="M93.21,46.79l-.08.5s-.14-.06-.23-.06c-.31,0-.48.32-.48.82v1.06h-.58v-2.37h.54l.02.26c.15-.18.32-.31.52-.31.14,0,.23.05.29.1h0Z"
                            />
                            <path
                                className="st54"
                                d="M94.96,46.69c.41,0,.73.22.85.49l.03-.44h.55v2.37h-.55l-.03-.44c-.12.27-.44.49-.85.49-.68,0-1.18-.55-1.18-1.23s.5-1.23,1.18-1.23h0ZM95.05,48.61c.4,0,.69-.31.69-.69s-.29-.69-.69-.69-.7.31-.7.69.29.69.7.69Z"
                            />
                            <path
                                className="st54"
                                d="M97.8,47.92c0,.41.35.69.7.69.22,0,.42-.08.61-.25v.55c-.14.12-.32.21-.57.24l-.11.19c.29,0,.48.1.48.33,0,.46-.77.43-1.01.43l.1-.26c.32,0,.59,0,.59-.15,0-.11-.13-.14-.28-.14h-.32l.17-.42c-.57-.12-.97-.62-.97-1.21,0-.67.52-1.23,1.22-1.23.31,0,.54.1.7.24v.55c-.19-.18-.38-.25-.61-.25-.35,0-.7.28-.7.69Z"
                            />
                            <path
                                className="st54"
                                d="M101.08,46.69c.41,0,.73.22.85.49l.03-.44h.55v2.37h-.55l-.03-.44c-.12.27-.44.49-.85.49-.68,0-1.18-.55-1.18-1.23s.5-1.23,1.18-1.23h0ZM100.73,45.5c.36,0,.5.32.78.32.16,0,.25-.08.25-.25l.48.09c-.03.33-.2.61-.6.61-.36,0-.5-.31-.78-.31-.15,0-.25.1-.25.25l-.48-.1c.03-.32.2-.61.6-.61ZM101.17,48.61c.4,0,.69-.31.69-.69s-.29-.69-.69-.69-.7.31-.7.69.29.69.7.69Z"
                            />
                            <path
                                className="st54"
                                d="M103.31,47.92c0-.68.53-1.23,1.28-1.23s1.27.55,1.27,1.23-.53,1.23-1.27,1.23-1.28-.55-1.28-1.23ZM105.28,47.92c0-.38-.29-.69-.69-.69s-.7.31-.7.69.29.69.7.69.69-.31.69-.69Z"
                            />
                            <path
                                className="st54"
                                d="M50.04,53.6h-1.8c0,.29.23.54.65.54.3,0,.49-.16.59-.32l.51.06c-.07.32-.44.78-1.1.78-.73,0-1.22-.55-1.22-1.25s.47-1.22,1.19-1.22,1.19.58,1.19,1.26v.15h0ZM48.24,53.2h1.22c-.02-.26-.25-.5-.61-.5s-.6.23-.61.5Z"
                            />
                            <path
                                className="st54"
                                d="M53.93,53.56h-.59v1.05h-.58v-3.33h1.25c.61,0,1.17.43,1.17,1.15,0,.51-.29.87-.67,1.04l.7,1.15h-.65l-.64-1.05h.01ZM53.35,53.01h.68c.32,0,.59-.23.59-.6s-.27-.6-.59-.6h-.68s0,1.2,0,1.2Z"
                            />
                            <path
                                className="st54"
                                d="M58.26,53.6h-1.8c0,.29.23.54.65.54.3,0,.49-.16.59-.32l.51.06c-.07.32-.44.78-1.1.78-.73,0-1.22-.55-1.22-1.25s.47-1.22,1.19-1.22,1.19.58,1.19,1.26v.15h0ZM56.46,53.2h1.22c-.02-.26-.25-.5-.61-.5s-.6.23-.61.5Z"
                            />
                            <path
                                className="st54"
                                d="M59.56,53.89c.03.17.22.28.5.28.2,0,.38-.07.38-.22,0-.19-.19-.23-.67-.38-.4-.12-.71-.32-.71-.7,0-.43.43-.69.88-.69.59,0,.94.33.95.73h-.58c0-.17-.2-.25-.36-.25-.15,0-.32.07-.32.21,0,.15.17.18.67.36.53.18.71.44.71.74,0,.44-.43.69-.97.69-.6,0-1.03-.25-1.06-.77,0,0,.58,0,.58,0Z"
                            />
                            <path
                                className="st54"
                                d="M61.84,51.6c0-.16.13-.3.3-.3s.3.13.3.3-.13.3-.3.3-.3-.13-.3-.3ZM62.43,54.6h-.58v-2.37h.58v2.37Z"
                            />
                            <path
                                className="st54"
                                d="M63.99,54.6h-.58v-3.52h.58v3.52Z"
                            />
                            <path
                                className="st54"
                                d="M64.92,51.6c0-.16.13-.3.3-.3s.3.13.3.3-.13.3-.3.3-.3-.13-.3-.3ZM65.51,54.6h-.58v-2.37h.58v2.37Z"
                            />
                            <path
                                className="st54"
                                d="M68.78,53.6h-1.8c.01.29.23.54.65.54.3,0,.49-.16.59-.32l.51.06c-.07.32-.44.78-1.1.78-.73,0-1.22-.55-1.22-1.25s.47-1.22,1.19-1.22,1.19.58,1.19,1.26v.15h-.01ZM67.33,51.75h-.52l.56-.74h.44l.56.74h-.51l-.26-.42-.27.42ZM66.98,53.2h1.22c-.02-.26-.25-.5-.61-.5s-.6.23-.61.5Z"
                            />
                            <path
                                className="st54"
                                d="M71.96,53.2v1.4h-.58v-1.14c0-.55-.2-.74-.52-.74-.4,0-.64.31-.66.69v1.19h-.58v-2.37h.54l.03.35c.23-.23.53-.4.89-.4.57,0,.87.37.87,1.02h.01Z"
                            />
                            <path
                                className="st54"
                                d="M74.1,52.73c-.35,0-.7.28-.7.69s.35.69.7.69c.22,0,.42-.08.61-.25v.55c-.16.14-.39.24-.7.24-.7,0-1.22-.56-1.22-1.23s.52-1.23,1.22-1.23c.31,0,.54.1.7.24v.55c-.19-.18-.38-.25-.61-.25Z"
                            />
                            <path
                                className="st54"
                                d="M75.55,51.6c0-.16.13-.3.3-.3s.3.13.3.3-.13.3-.3.3-.3-.13-.3-.3ZM76.14,54.6h-.58v-2.37h.58v2.37Z"
                            />
                            <path
                                className="st54"
                                d="M78.21,52.18c.41,0,.73.22.85.49l.03-.44h.55v2.37h-.55l-.03-.44c-.12.27-.44.49-.85.49-.68,0-1.18-.55-1.18-1.23s.5-1.23,1.18-1.23h0ZM78.31,54.11c.4,0,.69-.31.69-.69s-.29-.69-.69-.69-.7.31-.7.69.29.69.7.69Z"
                            />
                            <g className="st147">
                                <rect
                                    className="st56"
                                    x="14.4"
                                    y="23.4"
                                    width="12.24"
                                    height="15.01"
                                />
                            </g>
                            <g className="st73">
                                <rect
                                    className="st37"
                                    x="29.91"
                                    y="37.64"
                                    width="15.01"
                                    height="16.42"
                                />
                            </g>
                            <g className="st130">
                                <rect
                                    className="st133"
                                    x="19.01"
                                    y="20.2"
                                    width="25.12"
                                    height="30.66"
                                />
                            </g>
                            <path
                                className="st23"
                                d="M37.88,50.64s-.08.09-.12.14l.02-.02s.07-.08.1-.12M38.74,49.53c-.22.31-.45.61-.7.91,0,0-.03.02-.04.03,2.5-3.21,3.35-7.16,1.19-10.42-2.22-3.36-8.32-3.08-10.54-7.97-2.22-4.9-3.27-8.74-9.31-6.85h0c4.46-1.84,6.34.5,7.24,1.91.85,1.34,1.52,3.04,2.33,4.83.97,2.13,2.7,3.27,4.74,4.24,1.75.84,3.96,1.61,5.29,3.07.18.2.34.41.49.63,1,1.51,2.31,5.32-.7,9.64v-.02Z"
                            />
                            <g className="st93">
                                <g className="st15">
                                    <rect
                                        className="st1"
                                        x="9.36"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st82"
                                        x="9.58"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st89"
                                        x="9.79"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st150"
                                        x="10"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st0"
                                        x="10.21"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st50"
                                        x="10.42"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st145"
                                        x="10.64"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st106"
                                        x="10.85"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st72"
                                        x="11.06"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st72"
                                        x="11.27"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st151"
                                        x="11.48"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st110"
                                        x="11.69"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st110"
                                        x="11.91"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st110"
                                        x="12.12"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st97"
                                        x="12.33"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st115"
                                        x="12.54"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st103"
                                        x="12.75"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st138"
                                        x="12.97"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st11"
                                        x="13.18"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st60"
                                        x="13.39"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st6"
                                        x="13.6"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st90"
                                        x="13.81"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st83"
                                        x="14.02"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st94"
                                        x="14.24"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st57"
                                        x="14.45"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st71"
                                        x="14.66"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st123"
                                        x="14.87"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st35"
                                        x="15.08"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st107"
                                        x="15.3"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st135"
                                        x="15.51"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st109"
                                        x="15.72"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st143"
                                        x="15.93"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st16"
                                        x="16.14"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st148"
                                        x="16.35"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st68"
                                        x="16.57"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st113"
                                        x="16.78"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st47"
                                        x="16.99"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st114"
                                        x="17.2"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st77"
                                        x="17.41"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st55"
                                        x="17.63"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st136"
                                        x="17.84"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st62"
                                        x="18.05"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st79"
                                        x="18.26"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st108"
                                        x="18.47"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st108"
                                        x="18.68"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st124"
                                        x="18.9"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st45"
                                        x="19.11"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st61"
                                        x="19.32"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st61"
                                        x="19.53"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st9"
                                        x="19.74"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st141"
                                        x="19.96"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st100"
                                        x="20.17"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st48"
                                        x="20.38"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st132"
                                        x="20.59"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st33"
                                        x="20.8"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st131"
                                        x="21.02"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st64"
                                        x="21.23"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st81"
                                        x="21.44"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st91"
                                        x="21.65"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st92"
                                        x="21.86"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st78"
                                        x="22.07"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st137"
                                        x="22.29"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st137"
                                        x="22.5"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st13"
                                        x="22.71"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st80"
                                        x="22.92"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st59"
                                        x="23.13"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st111"
                                        x="23.35"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st12"
                                        x="23.56"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st49"
                                        x="23.77"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st119"
                                        x="23.98"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st102"
                                        x="24.19"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st74"
                                        x="24.4"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st125"
                                        x="24.62"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st104"
                                        x="24.83"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st7"
                                        x="25.04"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st85"
                                        x="25.25"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st101"
                                        x="25.46"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st63"
                                        x="25.68"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st5"
                                        x="25.89"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st27"
                                        x="26.1"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st88"
                                        x="26.31"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st36"
                                        x="26.52"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st87"
                                        x="26.73"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st29"
                                        x="26.95"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st99"
                                        x="27.16"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st129"
                                        x="27.37"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st142"
                                        x="27.58"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st69"
                                        x="27.79"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st149"
                                        x="28.01"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st118"
                                        x="28.22"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st122"
                                        x="28.43"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st66"
                                        x="28.64"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st10"
                                        x="28.85"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st10"
                                        x="29.07"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st30"
                                        x="29.28"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st30"
                                        x="29.49"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st58"
                                        x="29.7"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st26"
                                        x="29.91"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st70"
                                        x="30.12"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st70"
                                        x="30.34"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st75"
                                        x="30.55"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st75"
                                        x="30.76"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st155"
                                        x="30.97"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st46"
                                        x="31.18"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st153"
                                        x="31.4"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st96"
                                        x="31.61"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st4"
                                        x="31.82"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st128"
                                        x="32.03"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st128"
                                        x="32.24"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st121"
                                        x="32.45"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st120"
                                        x="32.67"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st126"
                                        x="32.88"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st146"
                                        x="33.09"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st134"
                                        x="33.3"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st144"
                                        x="33.51"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st144"
                                        x="33.73"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st140"
                                        x="33.94"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st67"
                                        x="34.15"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st38"
                                        x="34.36"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st31"
                                        x="34.57"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st40"
                                        x="34.78"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st39"
                                        x="35"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st51"
                                        x="35.21"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st65"
                                        x="35.42"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st95"
                                        x="35.63"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st43"
                                        x="35.84"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st98"
                                        x="36.06"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st32"
                                        x="36.27"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st76"
                                        x="36.48"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st127"
                                        x="36.69"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st117"
                                        x="36.9"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st86"
                                        x="37.12"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st112"
                                        x="37.33"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                    <rect
                                        className="st14"
                                        x="37.54"
                                        y="39.59"
                                        width=".21"
                                        height="17.39"
                                    />
                                </g>
                                <rect
                                    className="st105"
                                    x="8.83"
                                    y="41.02"
                                    width="27.92"
                                    height="17.06"
                                />
                            </g>
                            <g className="st84">
                                <rect
                                    className="st8"
                                    x="9.36"
                                    y="25.46"
                                    width="14.46"
                                    height="30.91"
                                />
                            </g>
                            <path
                                className="st22"
                                d="M25.54,56.35c-8.93,0-16.18-7.24-16.18-16.18,0,4.62,4.05,3.23,8.34,2.01-.27,5.76-3.18,13.17,7.83,14.16"
                            />
                            <path className="st20" d="M13.56,47.72h0Z" />
                            <path
                                className="st21"
                                d="M37.77,50.76s-.02,0-.04.02c-.4.33-2.15,1.67-3.72.86-1.55-.8-2.46-2.76-2.82-3.54-.24.13-.49.26-.75.38h0c1.7,2.93,3.44,5.2,6.35,3.12.31-.23.63-.49.96-.8h0s0,0,0,0v-.03Z"
                            />
                            <path
                                className="st23"
                                d="M17.26,26.28c.14-.08.27-.16.41-.24-5.64,4.15-.9,8.86-.07,13.71,1,5.85-4.71,15.46,7.94,16.6-5.83-.03-7.53-2.84-8.04-4.01-.88-2.03-.66-4.53-.42-6.67.11-1.03.25-2.06.31-3.09.06-.91.08-1.87-.08-2.78-.19-1.13-.6-2.23-1.01-3.29-.64-1.64-1.5-3.51-1.63-5.32-.14-1.98.93-3.86,2.58-4.92"
                            />
                            <path
                                className="st23"
                                d="M17.71,42.19c2.57-.73,5.23-1.4,7.17-.69,5.29,1.96,6.41,15.39,12.82,9.33-3.14,3.49-5.39.94-6.37-.43-.83-1.16-1.51-2.46-2.21-3.7-.97-1.71-2.4-4.21-4.34-4.93-1.89-.7-4.65.04-6.52.56-.19.05-.37.1-.56.16,0-.1.01-.2.02-.3"
                            />
                            <path
                                className="st17"
                                d="M17.71,42.21c1.15-.33,2.33-.64,3.44-.83-1.34,5.15-5.05,13.08,4.39,14.99-11.01-.99-8.11-8.4-7.83-14.16"
                            />
                            <path
                                className="st18"
                                d="M17.71,42.19l.96-.27c.11,1.29-.67,4.5-.68,7.29-.01,4.38,2.77,6.42,7.55,7.14-11.01-.99-8.11-8.4-7.83-14.16"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

